/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedWeekdayCandidatesIndexRouteImport } from './routes/_authenticated/weekday-candidates/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTraxcnCompaniesIndexRouteImport } from './routes/_authenticated/traxcn-companies/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedScoringIndexRouteImport } from './routes/_authenticated/scoring/index'
import { Route as AuthenticatedResumeCandidatesIndexRouteImport } from './routes/_authenticated/resume-candidates/index'
import { Route as AuthenticatedNaukriCandidatesIndexRouteImport } from './routes/_authenticated/naukri-candidates/index'
import { Route as AuthenticatedMarkedCandidatesIndexRouteImport } from './routes/_authenticated/marked-candidates/index'
import { Route as AuthenticatedLinkedinJobListIndexRouteImport } from './routes/_authenticated/linkedin-job-list/index'
import { Route as AuthenticatedLinkedinExtCandidatesIndexRouteImport } from './routes/_authenticated/linkedin-ext-candidates/index'
import { Route as AuthenticatedLinkdapiCandidatesIndexRouteImport } from './routes/_authenticated/linkdapi-candidates/index'
import { Route as AuthenticatedLemlistCompaniesIndexRouteImport } from './routes/_authenticated/lemlist-companies/index'
import { Route as AuthenticatedLemlistCandidatesIndexRouteImport } from './routes/_authenticated/lemlist-candidates/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedJobCreationIndexRouteImport } from './routes/_authenticated/job-creation/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedExtructCompaniesIndexRouteImport } from './routes/_authenticated/extruct-companies/index'
import { Route as AuthenticatedEvaluationPromptsIndexRouteImport } from './routes/_authenticated/evaluation-prompts/index'
import { Route as AuthenticatedEvaluationPromptCreationIndexRouteImport } from './routes/_authenticated/evaluation-prompt-creation/index'
import { Route as AuthenticatedCompanyJobsIndexRouteImport } from './routes/_authenticated/company-jobs/index'
import { Route as AuthenticatedCompanyChatIndexRouteImport } from './routes/_authenticated/company-chat/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedChangelogIndexRouteImport } from './routes/_authenticated/changelog/index'
import { Route as AuthenticatedCandidatesIndexRouteImport } from './routes/_authenticated/candidates/index'
import { Route as AuthenticatedCandidateChatIndexRouteImport } from './routes/_authenticated/candidate-chat/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedApolloCompaniesIndexRouteImport } from './routes/_authenticated/apollo-companies/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsLinkedinRouteImport } from './routes/_authenticated/settings/linkedin'
import { Route as AuthenticatedSettingsHiristRouteImport } from './routes/_authenticated/settings/hirist'
import { Route as AuthenticatedSettingsExtructRouteImport } from './routes/_authenticated/settings/extruct'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedAdminWeekdayPlaygroundRouteImport } from './routes/_authenticated/admin/weekday-playground'
import { Route as AuthenticatedAdminWeekdayEnrichRouteImport } from './routes/_authenticated/admin/weekday-enrich'
import { Route as AuthenticatedAdminWeekdayCredentialsRouteImport } from './routes/_authenticated/admin/weekday-credentials'
import { Route as AuthenticatedAdminWeekdayCompaniesRouteImport } from './routes/_authenticated/admin/weekday-companies'
import { Route as AuthenticatedAdminSignalhirePlaygroundRouteImport } from './routes/_authenticated/admin/signalhire-playground'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminProfileDownloadsRouteImport } from './routes/_authenticated/admin/profile-downloads'
import { Route as AuthenticatedAdminPipelineRunsRouteImport } from './routes/_authenticated/admin/pipeline-runs'
import { Route as AuthenticatedAdminLemlistPlaygroundRouteImport } from './routes/_authenticated/admin/lemlist-playground'
import { Route as AuthenticatedAdminLemlistCompanyLookupRouteImport } from './routes/_authenticated/admin/lemlist-company-lookup'
import { Route as AuthenticatedAdminJobsPlaygroundRouteImport } from './routes/_authenticated/admin/jobs-playground'
import { Route as AuthenticatedAdminGeminiPlaygroundRouteImport } from './routes/_authenticated/admin/gemini-playground'
import { Route as AuthenticatedAdminExtructSimilarHistoryRouteImport } from './routes/_authenticated/admin/extruct-similar-history'
import { Route as AuthenticatedAdminExtructSimilarRouteImport } from './routes/_authenticated/admin/extruct-similar'
import { Route as AuthenticatedAdminExtructLookupRouteImport } from './routes/_authenticated/admin/extruct-lookup'
import { Route as AuthenticatedAdminExperienceExtractionRouteImport } from './routes/_authenticated/admin/experience-extraction'
import { Route as AuthenticatedAdminEvaluationJobsRouteImport } from './routes/_authenticated/admin/evaluation-jobs'
import { Route as AuthenticatedAdminErrorLogsRouteImport } from './routes/_authenticated/admin/error-logs'
import { Route as AuthenticatedAdminCostRouteImport } from './routes/_authenticated/admin/cost'
import { Route as AuthenticatedAdminCopilotChatRouteImport } from './routes/_authenticated/admin/copilot-chat'
import { Route as AuthenticatedAdminCopilotRouteImport } from './routes/_authenticated/admin/copilot'
import { Route as AuthenticatedAdminCompanySheetRouteImport } from './routes/_authenticated/admin/company-sheet'
import { Route as AuthenticatedAdminCompanyExperiencesRouteImport } from './routes/_authenticated/admin/company-experiences'
import { Route as AuthenticatedAdminCompanyEnrichmentLiteRouteImport } from './routes/_authenticated/admin/company-enrichment-lite'
import { Route as AuthenticatedAdminCompanyEnrichmentRouteImport } from './routes/_authenticated/admin/company-enrichment'
import { Route as AuthenticatedAdminBetterenrichRouteImport } from './routes/_authenticated/admin/betterenrich'
import { Route as AuthenticatedJobsJobIdRouteRouteImport } from './routes/_authenticated/jobs/$jobId/route'
import { Route as AuthenticatedAdminWeekdaySearchesRouteRouteImport } from './routes/_authenticated/admin/weekday-searches/route'
import { Route as AuthenticatedTraxcnCompaniesIdIndexRouteImport } from './routes/_authenticated/traxcn-companies/$id/index'
import { Route as AuthenticatedScoringConversationIdIndexRouteImport } from './routes/_authenticated/scoring/$conversationId/index'
import { Route as AuthenticatedNaukriCandidatesIdIndexRouteImport } from './routes/_authenticated/naukri-candidates/$id/index'
import { Route as AuthenticatedLinkedinSalesNavigatorIndexRouteImport } from './routes/_authenticated/linkedin/sales-navigator/index'
import { Route as AuthenticatedLinkedinCandidatesIndexRouteImport } from './routes/_authenticated/linkedin/candidates/index'
import { Route as AuthenticatedJobsJobIdIndexRouteImport } from './routes/_authenticated/jobs/$jobId/index'
import { Route as AuthenticatedHiristJobsIndexRouteImport } from './routes/_authenticated/hirist/jobs/index'
import { Route as AuthenticatedCompanyJobsTracxnIndexRouteImport } from './routes/_authenticated/company-jobs/tracxn/index'
import { Route as AuthenticatedCompanyJobsMarkedIndexRouteImport } from './routes/_authenticated/company-jobs/marked/index'
import { Route as AuthenticatedCompanyJobsJobIdIndexRouteImport } from './routes/_authenticated/company-jobs/$jobId/index'
import { Route as AuthenticatedCompanyChatConversationIdIndexRouteImport } from './routes/_authenticated/company-chat/$conversationId/index'
import { Route as AuthenticatedCompaniesUidIndexRouteImport } from './routes/_authenticated/companies/$uid/index'
import { Route as AuthenticatedCandidatesUidIndexRouteImport } from './routes/_authenticated/candidates/$uid/index'
import { Route as AuthenticatedCandidateChatConversationIdIndexRouteImport } from './routes/_authenticated/candidate-chat/$conversationId/index'
import { Route as AuthenticatedAdminWeekdaySearchesIndexRouteImport } from './routes/_authenticated/admin/weekday-searches/index'
import { Route as AuthenticatedAdminResumeExtractionPlaygroundIndexRouteImport } from './routes/_authenticated/admin/resume-extraction-playground/index'
import { Route as AuthenticatedAdminEvalPlaygroundIndexRouteImport } from './routes/_authenticated/admin/eval-playground/index'
import { Route as AuthenticatedScoringConversationIdViewRouteImport } from './routes/_authenticated/scoring/$conversationId/view'
import { Route as AuthenticatedScoringConversationIdEvaluateRouteImport } from './routes/_authenticated/scoring/$conversationId/evaluate'
import { Route as AuthenticatedScoringConversationIdDiffRouteImport } from './routes/_authenticated/scoring/$conversationId/diff'
import { Route as AuthenticatedLinkedinSalesNavigatorNewRouteImport } from './routes/_authenticated/linkedin/sales-navigator/new'
import { Route as AuthenticatedLinkedinSalesNavigatorBuilderRouteImport } from './routes/_authenticated/linkedin/sales-navigator/builder'
import { Route as AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRouteImport } from './routes/_authenticated/linkedin-job-list/$linkedinJobId/applicants'
import { Route as AuthenticatedJobsJobIdScoringRouteImport } from './routes/_authenticated/jobs/$jobId/scoring'
import { Route as AuthenticatedJobsJobIdEvaluationsRouteImport } from './routes/_authenticated/jobs/$jobId/evaluations'
import { Route as AuthenticatedJobsJobIdEditRouteImport } from './routes/_authenticated/jobs/$jobId/edit'
import { Route as AuthenticatedJobsJobIdCandidatesRouteImport } from './routes/_authenticated/jobs/$jobId/candidates'
import { Route as AuthenticatedJobsJobIdActivityRouteImport } from './routes/_authenticated/jobs/$jobId/activity'
import { Route as AuthenticatedEvaluationPromptPromptIdEditRouteImport } from './routes/_authenticated/evaluation-prompt/$promptId/edit'
import { Route as AuthenticatedAdminWeekdaySearchesSearchIdRouteImport } from './routes/_authenticated/admin/weekday-searches/$searchId'
import { Route as AuthenticatedAdminResumeExtractionPlaygroundHistoryRouteImport } from './routes/_authenticated/admin/resume-extraction-playground/history'
import { Route as AuthenticatedAdminResumeExtractionPlaygroundSessionIdRouteImport } from './routes/_authenticated/admin/resume-extraction-playground/$sessionId'
import { Route as AuthenticatedAdminEvalPlaygroundHistoryRouteImport } from './routes/_authenticated/admin/eval-playground/history'
import { Route as AuthenticatedAdminEvalPlaygroundSessionIdRouteImport } from './routes/_authenticated/admin/eval-playground/$sessionId'
import { Route as AuthenticatedLinkedinSalesNavigatorJobIdIndexRouteImport } from './routes/_authenticated/linkedin/sales-navigator/$jobId/index'
import { Route as AuthenticatedLinkedinCandidatesUsernameIndexRouteImport } from './routes/_authenticated/linkedin/candidates/$username/index'
import { Route as AuthenticatedJobsJobIdSourcesIndexRouteImport } from './routes/_authenticated/jobs/$jobId/sources/index'
import { Route as AuthenticatedHiristJobsJobIdIndexRouteImport } from './routes/_authenticated/hirist/jobs/$jobId/index'
import { Route as AuthenticatedJobsJobIdSourcesSourceIdRouteImport } from './routes/_authenticated/jobs/$jobId/sources/$sourceId'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedWeekdayCandidatesIndexRoute =
  AuthenticatedWeekdayCandidatesIndexRouteImport.update({
    id: '/weekday-candidates/',
    path: '/weekday-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTraxcnCompaniesIndexRoute =
  AuthenticatedTraxcnCompaniesIndexRouteImport.update({
    id: '/traxcn-companies/',
    path: '/traxcn-companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedScoringIndexRoute =
  AuthenticatedScoringIndexRouteImport.update({
    id: '/scoring/',
    path: '/scoring/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResumeCandidatesIndexRoute =
  AuthenticatedResumeCandidatesIndexRouteImport.update({
    id: '/resume-candidates/',
    path: '/resume-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNaukriCandidatesIndexRoute =
  AuthenticatedNaukriCandidatesIndexRouteImport.update({
    id: '/naukri-candidates/',
    path: '/naukri-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarkedCandidatesIndexRoute =
  AuthenticatedMarkedCandidatesIndexRouteImport.update({
    id: '/marked-candidates/',
    path: '/marked-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinJobListIndexRoute =
  AuthenticatedLinkedinJobListIndexRouteImport.update({
    id: '/linkedin-job-list/',
    path: '/linkedin-job-list/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinExtCandidatesIndexRoute =
  AuthenticatedLinkedinExtCandidatesIndexRouteImport.update({
    id: '/linkedin-ext-candidates/',
    path: '/linkedin-ext-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkdapiCandidatesIndexRoute =
  AuthenticatedLinkdapiCandidatesIndexRouteImport.update({
    id: '/linkdapi-candidates/',
    path: '/linkdapi-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLemlistCompaniesIndexRoute =
  AuthenticatedLemlistCompaniesIndexRouteImport.update({
    id: '/lemlist-companies/',
    path: '/lemlist-companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLemlistCandidatesIndexRoute =
  AuthenticatedLemlistCandidatesIndexRouteImport.update({
    id: '/lemlist-candidates/',
    path: '/lemlist-candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedJobCreationIndexRoute =
  AuthenticatedJobCreationIndexRouteImport.update({
    id: '/job-creation/',
    path: '/job-creation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExtructCompaniesIndexRoute =
  AuthenticatedExtructCompaniesIndexRouteImport.update({
    id: '/extruct-companies/',
    path: '/extruct-companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEvaluationPromptsIndexRoute =
  AuthenticatedEvaluationPromptsIndexRouteImport.update({
    id: '/evaluation-prompts/',
    path: '/evaluation-prompts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEvaluationPromptCreationIndexRoute =
  AuthenticatedEvaluationPromptCreationIndexRouteImport.update({
    id: '/evaluation-prompt-creation/',
    path: '/evaluation-prompt-creation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyJobsIndexRoute =
  AuthenticatedCompanyJobsIndexRouteImport.update({
    id: '/company-jobs/',
    path: '/company-jobs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyChatIndexRoute =
  AuthenticatedCompanyChatIndexRouteImport.update({
    id: '/company-chat/',
    path: '/company-chat/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChangelogIndexRoute =
  AuthenticatedChangelogIndexRouteImport.update({
    id: '/changelog/',
    path: '/changelog/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCandidatesIndexRoute =
  AuthenticatedCandidatesIndexRouteImport.update({
    id: '/candidates/',
    path: '/candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCandidateChatIndexRoute =
  AuthenticatedCandidateChatIndexRouteImport.update({
    id: '/candidate-chat/',
    path: '/candidate-chat/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedApolloCompaniesIndexRoute =
  AuthenticatedApolloCompaniesIndexRouteImport.update({
    id: '/apollo-companies/',
    path: '/apollo-companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsLinkedinRoute =
  AuthenticatedSettingsLinkedinRouteImport.update({
    id: '/linkedin',
    path: '/linkedin',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsHiristRoute =
  AuthenticatedSettingsHiristRouteImport.update({
    id: '/hirist',
    path: '/hirist',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsExtructRoute =
  AuthenticatedSettingsExtructRouteImport.update({
    id: '/extruct',
    path: '/extruct',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminWeekdayPlaygroundRoute =
  AuthenticatedAdminWeekdayPlaygroundRouteImport.update({
    id: '/weekday-playground',
    path: '/weekday-playground',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminWeekdayEnrichRoute =
  AuthenticatedAdminWeekdayEnrichRouteImport.update({
    id: '/weekday-enrich',
    path: '/weekday-enrich',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminWeekdayCredentialsRoute =
  AuthenticatedAdminWeekdayCredentialsRouteImport.update({
    id: '/weekday-credentials',
    path: '/weekday-credentials',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminWeekdayCompaniesRoute =
  AuthenticatedAdminWeekdayCompaniesRouteImport.update({
    id: '/weekday-companies',
    path: '/weekday-companies',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSignalhirePlaygroundRoute =
  AuthenticatedAdminSignalhirePlaygroundRouteImport.update({
    id: '/signalhire-playground',
    path: '/signalhire-playground',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminProfileDownloadsRoute =
  AuthenticatedAdminProfileDownloadsRouteImport.update({
    id: '/profile-downloads',
    path: '/profile-downloads',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminPipelineRunsRoute =
  AuthenticatedAdminPipelineRunsRouteImport.update({
    id: '/pipeline-runs',
    path: '/pipeline-runs',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminLemlistPlaygroundRoute =
  AuthenticatedAdminLemlistPlaygroundRouteImport.update({
    id: '/lemlist-playground',
    path: '/lemlist-playground',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminLemlistCompanyLookupRoute =
  AuthenticatedAdminLemlistCompanyLookupRouteImport.update({
    id: '/lemlist-company-lookup',
    path: '/lemlist-company-lookup',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminJobsPlaygroundRoute =
  AuthenticatedAdminJobsPlaygroundRouteImport.update({
    id: '/jobs-playground',
    path: '/jobs-playground',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminGeminiPlaygroundRoute =
  AuthenticatedAdminGeminiPlaygroundRouteImport.update({
    id: '/gemini-playground',
    path: '/gemini-playground',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminExtructSimilarHistoryRoute =
  AuthenticatedAdminExtructSimilarHistoryRouteImport.update({
    id: '/extruct-similar-history',
    path: '/extruct-similar-history',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminExtructSimilarRoute =
  AuthenticatedAdminExtructSimilarRouteImport.update({
    id: '/extruct-similar',
    path: '/extruct-similar',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminExtructLookupRoute =
  AuthenticatedAdminExtructLookupRouteImport.update({
    id: '/extruct-lookup',
    path: '/extruct-lookup',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminExperienceExtractionRoute =
  AuthenticatedAdminExperienceExtractionRouteImport.update({
    id: '/experience-extraction',
    path: '/experience-extraction',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEvaluationJobsRoute =
  AuthenticatedAdminEvaluationJobsRouteImport.update({
    id: '/evaluation-jobs',
    path: '/evaluation-jobs',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminErrorLogsRoute =
  AuthenticatedAdminErrorLogsRouteImport.update({
    id: '/error-logs',
    path: '/error-logs',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCostRoute = AuthenticatedAdminCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminCopilotChatRoute =
  AuthenticatedAdminCopilotChatRouteImport.update({
    id: '/copilot-chat',
    path: '/copilot-chat',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCopilotRoute =
  AuthenticatedAdminCopilotRouteImport.update({
    id: '/copilot',
    path: '/copilot',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCompanySheetRoute =
  AuthenticatedAdminCompanySheetRouteImport.update({
    id: '/company-sheet',
    path: '/company-sheet',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCompanyExperiencesRoute =
  AuthenticatedAdminCompanyExperiencesRouteImport.update({
    id: '/company-experiences',
    path: '/company-experiences',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCompanyEnrichmentLiteRoute =
  AuthenticatedAdminCompanyEnrichmentLiteRouteImport.update({
    id: '/company-enrichment-lite',
    path: '/company-enrichment-lite',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCompanyEnrichmentRoute =
  AuthenticatedAdminCompanyEnrichmentRouteImport.update({
    id: '/company-enrichment',
    path: '/company-enrichment',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminBetterenrichRoute =
  AuthenticatedAdminBetterenrichRouteImport.update({
    id: '/betterenrich',
    path: '/betterenrich',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedJobsJobIdRouteRoute =
  AuthenticatedJobsJobIdRouteRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminWeekdaySearchesRouteRoute =
  AuthenticatedAdminWeekdaySearchesRouteRouteImport.update({
    id: '/weekday-searches',
    path: '/weekday-searches',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedTraxcnCompaniesIdIndexRoute =
  AuthenticatedTraxcnCompaniesIdIndexRouteImport.update({
    id: '/traxcn-companies/$id/',
    path: '/traxcn-companies/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedScoringConversationIdIndexRoute =
  AuthenticatedScoringConversationIdIndexRouteImport.update({
    id: '/scoring/$conversationId/',
    path: '/scoring/$conversationId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNaukriCandidatesIdIndexRoute =
  AuthenticatedNaukriCandidatesIdIndexRouteImport.update({
    id: '/naukri-candidates/$id/',
    path: '/naukri-candidates/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinSalesNavigatorIndexRoute =
  AuthenticatedLinkedinSalesNavigatorIndexRouteImport.update({
    id: '/linkedin/sales-navigator/',
    path: '/linkedin/sales-navigator/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinCandidatesIndexRoute =
  AuthenticatedLinkedinCandidatesIndexRouteImport.update({
    id: '/linkedin/candidates/',
    path: '/linkedin/candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsJobIdIndexRoute =
  AuthenticatedJobsJobIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedHiristJobsIndexRoute =
  AuthenticatedHiristJobsIndexRouteImport.update({
    id: '/hirist/jobs/',
    path: '/hirist/jobs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyJobsTracxnIndexRoute =
  AuthenticatedCompanyJobsTracxnIndexRouteImport.update({
    id: '/company-jobs/tracxn/',
    path: '/company-jobs/tracxn/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyJobsMarkedIndexRoute =
  AuthenticatedCompanyJobsMarkedIndexRouteImport.update({
    id: '/company-jobs/marked/',
    path: '/company-jobs/marked/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyJobsJobIdIndexRoute =
  AuthenticatedCompanyJobsJobIdIndexRouteImport.update({
    id: '/company-jobs/$jobId/',
    path: '/company-jobs/$jobId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyChatConversationIdIndexRoute =
  AuthenticatedCompanyChatConversationIdIndexRouteImport.update({
    id: '/company-chat/$conversationId/',
    path: '/company-chat/$conversationId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesUidIndexRoute =
  AuthenticatedCompaniesUidIndexRouteImport.update({
    id: '/companies/$uid/',
    path: '/companies/$uid/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCandidatesUidIndexRoute =
  AuthenticatedCandidatesUidIndexRouteImport.update({
    id: '/candidates/$uid/',
    path: '/candidates/$uid/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCandidateChatConversationIdIndexRoute =
  AuthenticatedCandidateChatConversationIdIndexRouteImport.update({
    id: '/candidate-chat/$conversationId/',
    path: '/candidate-chat/$conversationId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminWeekdaySearchesIndexRoute =
  AuthenticatedAdminWeekdaySearchesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminWeekdaySearchesRouteRoute,
  } as any)
const AuthenticatedAdminResumeExtractionPlaygroundIndexRoute =
  AuthenticatedAdminResumeExtractionPlaygroundIndexRouteImport.update({
    id: '/resume-extraction-playground/',
    path: '/resume-extraction-playground/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEvalPlaygroundIndexRoute =
  AuthenticatedAdminEvalPlaygroundIndexRouteImport.update({
    id: '/eval-playground/',
    path: '/eval-playground/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedScoringConversationIdViewRoute =
  AuthenticatedScoringConversationIdViewRouteImport.update({
    id: '/scoring/$conversationId/view',
    path: '/scoring/$conversationId/view',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedScoringConversationIdEvaluateRoute =
  AuthenticatedScoringConversationIdEvaluateRouteImport.update({
    id: '/scoring/$conversationId/evaluate',
    path: '/scoring/$conversationId/evaluate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedScoringConversationIdDiffRoute =
  AuthenticatedScoringConversationIdDiffRouteImport.update({
    id: '/scoring/$conversationId/diff',
    path: '/scoring/$conversationId/diff',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinSalesNavigatorNewRoute =
  AuthenticatedLinkedinSalesNavigatorNewRouteImport.update({
    id: '/linkedin/sales-navigator/new',
    path: '/linkedin/sales-navigator/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinSalesNavigatorBuilderRoute =
  AuthenticatedLinkedinSalesNavigatorBuilderRouteImport.update({
    id: '/linkedin/sales-navigator/builder',
    path: '/linkedin/sales-navigator/builder',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute =
  AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRouteImport.update({
    id: '/linkedin-job-list/$linkedinJobId/applicants',
    path: '/linkedin-job-list/$linkedinJobId/applicants',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsJobIdScoringRoute =
  AuthenticatedJobsJobIdScoringRouteImport.update({
    id: '/scoring',
    path: '/scoring',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdEvaluationsRoute =
  AuthenticatedJobsJobIdEvaluationsRouteImport.update({
    id: '/evaluations',
    path: '/evaluations',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdEditRoute =
  AuthenticatedJobsJobIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdCandidatesRoute =
  AuthenticatedJobsJobIdCandidatesRouteImport.update({
    id: '/candidates',
    path: '/candidates',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdActivityRoute =
  AuthenticatedJobsJobIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedEvaluationPromptPromptIdEditRoute =
  AuthenticatedEvaluationPromptPromptIdEditRouteImport.update({
    id: '/evaluation-prompt/$promptId/edit',
    path: '/evaluation-prompt/$promptId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminWeekdaySearchesSearchIdRoute =
  AuthenticatedAdminWeekdaySearchesSearchIdRouteImport.update({
    id: '/$searchId',
    path: '/$searchId',
    getParentRoute: () => AuthenticatedAdminWeekdaySearchesRouteRoute,
  } as any)
const AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute =
  AuthenticatedAdminResumeExtractionPlaygroundHistoryRouteImport.update({
    id: '/resume-extraction-playground/history',
    path: '/resume-extraction-playground/history',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute =
  AuthenticatedAdminResumeExtractionPlaygroundSessionIdRouteImport.update({
    id: '/resume-extraction-playground/$sessionId',
    path: '/resume-extraction-playground/$sessionId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEvalPlaygroundHistoryRoute =
  AuthenticatedAdminEvalPlaygroundHistoryRouteImport.update({
    id: '/eval-playground/history',
    path: '/eval-playground/history',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEvalPlaygroundSessionIdRoute =
  AuthenticatedAdminEvalPlaygroundSessionIdRouteImport.update({
    id: '/eval-playground/$sessionId',
    path: '/eval-playground/$sessionId',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute =
  AuthenticatedLinkedinSalesNavigatorJobIdIndexRouteImport.update({
    id: '/linkedin/sales-navigator/$jobId/',
    path: '/linkedin/sales-navigator/$jobId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLinkedinCandidatesUsernameIndexRoute =
  AuthenticatedLinkedinCandidatesUsernameIndexRouteImport.update({
    id: '/linkedin/candidates/$username/',
    path: '/linkedin/candidates/$username/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsJobIdSourcesIndexRoute =
  AuthenticatedJobsJobIdSourcesIndexRouteImport.update({
    id: '/sources/',
    path: '/sources/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedHiristJobsJobIdIndexRoute =
  AuthenticatedHiristJobsJobIdIndexRouteImport.update({
    id: '/hirist/jobs/$jobId/',
    path: '/hirist/jobs/$jobId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsJobIdSourcesSourceIdRoute =
  AuthenticatedJobsJobIdSourcesSourceIdRouteImport.update({
    id: '/sources/$sourceId',
    path: '/sources/$sourceId',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/admin/weekday-searches': typeof AuthenticatedAdminWeekdaySearchesRouteRouteWithChildren
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/admin/betterenrich': typeof AuthenticatedAdminBetterenrichRoute
  '/admin/company-enrichment': typeof AuthenticatedAdminCompanyEnrichmentRoute
  '/admin/company-enrichment-lite': typeof AuthenticatedAdminCompanyEnrichmentLiteRoute
  '/admin/company-experiences': typeof AuthenticatedAdminCompanyExperiencesRoute
  '/admin/company-sheet': typeof AuthenticatedAdminCompanySheetRoute
  '/admin/copilot': typeof AuthenticatedAdminCopilotRoute
  '/admin/copilot-chat': typeof AuthenticatedAdminCopilotChatRoute
  '/admin/cost': typeof AuthenticatedAdminCostRoute
  '/admin/error-logs': typeof AuthenticatedAdminErrorLogsRoute
  '/admin/evaluation-jobs': typeof AuthenticatedAdminEvaluationJobsRoute
  '/admin/experience-extraction': typeof AuthenticatedAdminExperienceExtractionRoute
  '/admin/extruct-lookup': typeof AuthenticatedAdminExtructLookupRoute
  '/admin/extruct-similar': typeof AuthenticatedAdminExtructSimilarRoute
  '/admin/extruct-similar-history': typeof AuthenticatedAdminExtructSimilarHistoryRoute
  '/admin/gemini-playground': typeof AuthenticatedAdminGeminiPlaygroundRoute
  '/admin/jobs-playground': typeof AuthenticatedAdminJobsPlaygroundRoute
  '/admin/lemlist-company-lookup': typeof AuthenticatedAdminLemlistCompanyLookupRoute
  '/admin/lemlist-playground': typeof AuthenticatedAdminLemlistPlaygroundRoute
  '/admin/pipeline-runs': typeof AuthenticatedAdminPipelineRunsRoute
  '/admin/profile-downloads': typeof AuthenticatedAdminProfileDownloadsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/signalhire-playground': typeof AuthenticatedAdminSignalhirePlaygroundRoute
  '/admin/weekday-companies': typeof AuthenticatedAdminWeekdayCompaniesRoute
  '/admin/weekday-credentials': typeof AuthenticatedAdminWeekdayCredentialsRoute
  '/admin/weekday-enrich': typeof AuthenticatedAdminWeekdayEnrichRoute
  '/admin/weekday-playground': typeof AuthenticatedAdminWeekdayPlaygroundRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/extruct': typeof AuthenticatedSettingsExtructRoute
  '/settings/hirist': typeof AuthenticatedSettingsHiristRoute
  '/settings/linkedin': typeof AuthenticatedSettingsLinkedinRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/apollo-companies': typeof AuthenticatedApolloCompaniesIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/candidate-chat': typeof AuthenticatedCandidateChatIndexRoute
  '/candidates': typeof AuthenticatedCandidatesIndexRoute
  '/changelog': typeof AuthenticatedChangelogIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/company-chat': typeof AuthenticatedCompanyChatIndexRoute
  '/company-jobs': typeof AuthenticatedCompanyJobsIndexRoute
  '/evaluation-prompt-creation': typeof AuthenticatedEvaluationPromptCreationIndexRoute
  '/evaluation-prompts': typeof AuthenticatedEvaluationPromptsIndexRoute
  '/extruct-companies': typeof AuthenticatedExtructCompaniesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/job-creation': typeof AuthenticatedJobCreationIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/lemlist-candidates': typeof AuthenticatedLemlistCandidatesIndexRoute
  '/lemlist-companies': typeof AuthenticatedLemlistCompaniesIndexRoute
  '/linkdapi-candidates': typeof AuthenticatedLinkdapiCandidatesIndexRoute
  '/linkedin-ext-candidates': typeof AuthenticatedLinkedinExtCandidatesIndexRoute
  '/linkedin-job-list': typeof AuthenticatedLinkedinJobListIndexRoute
  '/marked-candidates': typeof AuthenticatedMarkedCandidatesIndexRoute
  '/naukri-candidates': typeof AuthenticatedNaukriCandidatesIndexRoute
  '/resume-candidates': typeof AuthenticatedResumeCandidatesIndexRoute
  '/scoring': typeof AuthenticatedScoringIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/traxcn-companies': typeof AuthenticatedTraxcnCompaniesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/weekday-candidates': typeof AuthenticatedWeekdayCandidatesIndexRoute
  '/admin/eval-playground/$sessionId': typeof AuthenticatedAdminEvalPlaygroundSessionIdRoute
  '/admin/eval-playground/history': typeof AuthenticatedAdminEvalPlaygroundHistoryRoute
  '/admin/resume-extraction-playground/$sessionId': typeof AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute
  '/admin/resume-extraction-playground/history': typeof AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute
  '/admin/weekday-searches/$searchId': typeof AuthenticatedAdminWeekdaySearchesSearchIdRoute
  '/evaluation-prompt/$promptId/edit': typeof AuthenticatedEvaluationPromptPromptIdEditRoute
  '/jobs/$jobId/activity': typeof AuthenticatedJobsJobIdActivityRoute
  '/jobs/$jobId/candidates': typeof AuthenticatedJobsJobIdCandidatesRoute
  '/jobs/$jobId/edit': typeof AuthenticatedJobsJobIdEditRoute
  '/jobs/$jobId/evaluations': typeof AuthenticatedJobsJobIdEvaluationsRoute
  '/jobs/$jobId/scoring': typeof AuthenticatedJobsJobIdScoringRoute
  '/linkedin-job-list/$linkedinJobId/applicants': typeof AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute
  '/linkedin/sales-navigator/builder': typeof AuthenticatedLinkedinSalesNavigatorBuilderRoute
  '/linkedin/sales-navigator/new': typeof AuthenticatedLinkedinSalesNavigatorNewRoute
  '/scoring/$conversationId/diff': typeof AuthenticatedScoringConversationIdDiffRoute
  '/scoring/$conversationId/evaluate': typeof AuthenticatedScoringConversationIdEvaluateRoute
  '/scoring/$conversationId/view': typeof AuthenticatedScoringConversationIdViewRoute
  '/admin/eval-playground': typeof AuthenticatedAdminEvalPlaygroundIndexRoute
  '/admin/resume-extraction-playground': typeof AuthenticatedAdminResumeExtractionPlaygroundIndexRoute
  '/admin/weekday-searches/': typeof AuthenticatedAdminWeekdaySearchesIndexRoute
  '/candidate-chat/$conversationId': typeof AuthenticatedCandidateChatConversationIdIndexRoute
  '/candidates/$uid': typeof AuthenticatedCandidatesUidIndexRoute
  '/companies/$uid': typeof AuthenticatedCompaniesUidIndexRoute
  '/company-chat/$conversationId': typeof AuthenticatedCompanyChatConversationIdIndexRoute
  '/company-jobs/$jobId': typeof AuthenticatedCompanyJobsJobIdIndexRoute
  '/company-jobs/marked': typeof AuthenticatedCompanyJobsMarkedIndexRoute
  '/company-jobs/tracxn': typeof AuthenticatedCompanyJobsTracxnIndexRoute
  '/hirist/jobs': typeof AuthenticatedHiristJobsIndexRoute
  '/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexRoute
  '/linkedin/candidates': typeof AuthenticatedLinkedinCandidatesIndexRoute
  '/linkedin/sales-navigator': typeof AuthenticatedLinkedinSalesNavigatorIndexRoute
  '/naukri-candidates/$id': typeof AuthenticatedNaukriCandidatesIdIndexRoute
  '/scoring/$conversationId': typeof AuthenticatedScoringConversationIdIndexRoute
  '/traxcn-companies/$id': typeof AuthenticatedTraxcnCompaniesIdIndexRoute
  '/jobs/$jobId/sources/$sourceId': typeof AuthenticatedJobsJobIdSourcesSourceIdRoute
  '/hirist/jobs/$jobId': typeof AuthenticatedHiristJobsJobIdIndexRoute
  '/jobs/$jobId/sources': typeof AuthenticatedJobsJobIdSourcesIndexRoute
  '/linkedin/candidates/$username': typeof AuthenticatedLinkedinCandidatesUsernameIndexRoute
  '/linkedin/sales-navigator/$jobId': typeof AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/admin/betterenrich': typeof AuthenticatedAdminBetterenrichRoute
  '/admin/company-enrichment': typeof AuthenticatedAdminCompanyEnrichmentRoute
  '/admin/company-enrichment-lite': typeof AuthenticatedAdminCompanyEnrichmentLiteRoute
  '/admin/company-experiences': typeof AuthenticatedAdminCompanyExperiencesRoute
  '/admin/company-sheet': typeof AuthenticatedAdminCompanySheetRoute
  '/admin/copilot': typeof AuthenticatedAdminCopilotRoute
  '/admin/copilot-chat': typeof AuthenticatedAdminCopilotChatRoute
  '/admin/cost': typeof AuthenticatedAdminCostRoute
  '/admin/error-logs': typeof AuthenticatedAdminErrorLogsRoute
  '/admin/evaluation-jobs': typeof AuthenticatedAdminEvaluationJobsRoute
  '/admin/experience-extraction': typeof AuthenticatedAdminExperienceExtractionRoute
  '/admin/extruct-lookup': typeof AuthenticatedAdminExtructLookupRoute
  '/admin/extruct-similar': typeof AuthenticatedAdminExtructSimilarRoute
  '/admin/extruct-similar-history': typeof AuthenticatedAdminExtructSimilarHistoryRoute
  '/admin/gemini-playground': typeof AuthenticatedAdminGeminiPlaygroundRoute
  '/admin/jobs-playground': typeof AuthenticatedAdminJobsPlaygroundRoute
  '/admin/lemlist-company-lookup': typeof AuthenticatedAdminLemlistCompanyLookupRoute
  '/admin/lemlist-playground': typeof AuthenticatedAdminLemlistPlaygroundRoute
  '/admin/pipeline-runs': typeof AuthenticatedAdminPipelineRunsRoute
  '/admin/profile-downloads': typeof AuthenticatedAdminProfileDownloadsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/signalhire-playground': typeof AuthenticatedAdminSignalhirePlaygroundRoute
  '/admin/weekday-companies': typeof AuthenticatedAdminWeekdayCompaniesRoute
  '/admin/weekday-credentials': typeof AuthenticatedAdminWeekdayCredentialsRoute
  '/admin/weekday-enrich': typeof AuthenticatedAdminWeekdayEnrichRoute
  '/admin/weekday-playground': typeof AuthenticatedAdminWeekdayPlaygroundRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/extruct': typeof AuthenticatedSettingsExtructRoute
  '/settings/hirist': typeof AuthenticatedSettingsHiristRoute
  '/settings/linkedin': typeof AuthenticatedSettingsLinkedinRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/apollo-companies': typeof AuthenticatedApolloCompaniesIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/candidate-chat': typeof AuthenticatedCandidateChatIndexRoute
  '/candidates': typeof AuthenticatedCandidatesIndexRoute
  '/changelog': typeof AuthenticatedChangelogIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/company-chat': typeof AuthenticatedCompanyChatIndexRoute
  '/company-jobs': typeof AuthenticatedCompanyJobsIndexRoute
  '/evaluation-prompt-creation': typeof AuthenticatedEvaluationPromptCreationIndexRoute
  '/evaluation-prompts': typeof AuthenticatedEvaluationPromptsIndexRoute
  '/extruct-companies': typeof AuthenticatedExtructCompaniesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/job-creation': typeof AuthenticatedJobCreationIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/lemlist-candidates': typeof AuthenticatedLemlistCandidatesIndexRoute
  '/lemlist-companies': typeof AuthenticatedLemlistCompaniesIndexRoute
  '/linkdapi-candidates': typeof AuthenticatedLinkdapiCandidatesIndexRoute
  '/linkedin-ext-candidates': typeof AuthenticatedLinkedinExtCandidatesIndexRoute
  '/linkedin-job-list': typeof AuthenticatedLinkedinJobListIndexRoute
  '/marked-candidates': typeof AuthenticatedMarkedCandidatesIndexRoute
  '/naukri-candidates': typeof AuthenticatedNaukriCandidatesIndexRoute
  '/resume-candidates': typeof AuthenticatedResumeCandidatesIndexRoute
  '/scoring': typeof AuthenticatedScoringIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/traxcn-companies': typeof AuthenticatedTraxcnCompaniesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/weekday-candidates': typeof AuthenticatedWeekdayCandidatesIndexRoute
  '/admin/eval-playground/$sessionId': typeof AuthenticatedAdminEvalPlaygroundSessionIdRoute
  '/admin/eval-playground/history': typeof AuthenticatedAdminEvalPlaygroundHistoryRoute
  '/admin/resume-extraction-playground/$sessionId': typeof AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute
  '/admin/resume-extraction-playground/history': typeof AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute
  '/admin/weekday-searches/$searchId': typeof AuthenticatedAdminWeekdaySearchesSearchIdRoute
  '/evaluation-prompt/$promptId/edit': typeof AuthenticatedEvaluationPromptPromptIdEditRoute
  '/jobs/$jobId/activity': typeof AuthenticatedJobsJobIdActivityRoute
  '/jobs/$jobId/candidates': typeof AuthenticatedJobsJobIdCandidatesRoute
  '/jobs/$jobId/edit': typeof AuthenticatedJobsJobIdEditRoute
  '/jobs/$jobId/evaluations': typeof AuthenticatedJobsJobIdEvaluationsRoute
  '/jobs/$jobId/scoring': typeof AuthenticatedJobsJobIdScoringRoute
  '/linkedin-job-list/$linkedinJobId/applicants': typeof AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute
  '/linkedin/sales-navigator/builder': typeof AuthenticatedLinkedinSalesNavigatorBuilderRoute
  '/linkedin/sales-navigator/new': typeof AuthenticatedLinkedinSalesNavigatorNewRoute
  '/scoring/$conversationId/diff': typeof AuthenticatedScoringConversationIdDiffRoute
  '/scoring/$conversationId/evaluate': typeof AuthenticatedScoringConversationIdEvaluateRoute
  '/scoring/$conversationId/view': typeof AuthenticatedScoringConversationIdViewRoute
  '/admin/eval-playground': typeof AuthenticatedAdminEvalPlaygroundIndexRoute
  '/admin/resume-extraction-playground': typeof AuthenticatedAdminResumeExtractionPlaygroundIndexRoute
  '/admin/weekday-searches': typeof AuthenticatedAdminWeekdaySearchesIndexRoute
  '/candidate-chat/$conversationId': typeof AuthenticatedCandidateChatConversationIdIndexRoute
  '/candidates/$uid': typeof AuthenticatedCandidatesUidIndexRoute
  '/companies/$uid': typeof AuthenticatedCompaniesUidIndexRoute
  '/company-chat/$conversationId': typeof AuthenticatedCompanyChatConversationIdIndexRoute
  '/company-jobs/$jobId': typeof AuthenticatedCompanyJobsJobIdIndexRoute
  '/company-jobs/marked': typeof AuthenticatedCompanyJobsMarkedIndexRoute
  '/company-jobs/tracxn': typeof AuthenticatedCompanyJobsTracxnIndexRoute
  '/hirist/jobs': typeof AuthenticatedHiristJobsIndexRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdIndexRoute
  '/linkedin/candidates': typeof AuthenticatedLinkedinCandidatesIndexRoute
  '/linkedin/sales-navigator': typeof AuthenticatedLinkedinSalesNavigatorIndexRoute
  '/naukri-candidates/$id': typeof AuthenticatedNaukriCandidatesIdIndexRoute
  '/scoring/$conversationId': typeof AuthenticatedScoringConversationIdIndexRoute
  '/traxcn-companies/$id': typeof AuthenticatedTraxcnCompaniesIdIndexRoute
  '/jobs/$jobId/sources/$sourceId': typeof AuthenticatedJobsJobIdSourcesSourceIdRoute
  '/hirist/jobs/$jobId': typeof AuthenticatedHiristJobsJobIdIndexRoute
  '/jobs/$jobId/sources': typeof AuthenticatedJobsJobIdSourcesIndexRoute
  '/linkedin/candidates/$username': typeof AuthenticatedLinkedinCandidatesUsernameIndexRoute
  '/linkedin/sales-navigator/$jobId': typeof AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/weekday-searches': typeof AuthenticatedAdminWeekdaySearchesRouteRouteWithChildren
  '/_authenticated/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/_authenticated/admin/betterenrich': typeof AuthenticatedAdminBetterenrichRoute
  '/_authenticated/admin/company-enrichment': typeof AuthenticatedAdminCompanyEnrichmentRoute
  '/_authenticated/admin/company-enrichment-lite': typeof AuthenticatedAdminCompanyEnrichmentLiteRoute
  '/_authenticated/admin/company-experiences': typeof AuthenticatedAdminCompanyExperiencesRoute
  '/_authenticated/admin/company-sheet': typeof AuthenticatedAdminCompanySheetRoute
  '/_authenticated/admin/copilot': typeof AuthenticatedAdminCopilotRoute
  '/_authenticated/admin/copilot-chat': typeof AuthenticatedAdminCopilotChatRoute
  '/_authenticated/admin/cost': typeof AuthenticatedAdminCostRoute
  '/_authenticated/admin/error-logs': typeof AuthenticatedAdminErrorLogsRoute
  '/_authenticated/admin/evaluation-jobs': typeof AuthenticatedAdminEvaluationJobsRoute
  '/_authenticated/admin/experience-extraction': typeof AuthenticatedAdminExperienceExtractionRoute
  '/_authenticated/admin/extruct-lookup': typeof AuthenticatedAdminExtructLookupRoute
  '/_authenticated/admin/extruct-similar': typeof AuthenticatedAdminExtructSimilarRoute
  '/_authenticated/admin/extruct-similar-history': typeof AuthenticatedAdminExtructSimilarHistoryRoute
  '/_authenticated/admin/gemini-playground': typeof AuthenticatedAdminGeminiPlaygroundRoute
  '/_authenticated/admin/jobs-playground': typeof AuthenticatedAdminJobsPlaygroundRoute
  '/_authenticated/admin/lemlist-company-lookup': typeof AuthenticatedAdminLemlistCompanyLookupRoute
  '/_authenticated/admin/lemlist-playground': typeof AuthenticatedAdminLemlistPlaygroundRoute
  '/_authenticated/admin/pipeline-runs': typeof AuthenticatedAdminPipelineRunsRoute
  '/_authenticated/admin/profile-downloads': typeof AuthenticatedAdminProfileDownloadsRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/signalhire-playground': typeof AuthenticatedAdminSignalhirePlaygroundRoute
  '/_authenticated/admin/weekday-companies': typeof AuthenticatedAdminWeekdayCompaniesRoute
  '/_authenticated/admin/weekday-credentials': typeof AuthenticatedAdminWeekdayCredentialsRoute
  '/_authenticated/admin/weekday-enrich': typeof AuthenticatedAdminWeekdayEnrichRoute
  '/_authenticated/admin/weekday-playground': typeof AuthenticatedAdminWeekdayPlaygroundRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/extruct': typeof AuthenticatedSettingsExtructRoute
  '/_authenticated/settings/hirist': typeof AuthenticatedSettingsHiristRoute
  '/_authenticated/settings/linkedin': typeof AuthenticatedSettingsLinkedinRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/apollo-companies/': typeof AuthenticatedApolloCompaniesIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/candidate-chat/': typeof AuthenticatedCandidateChatIndexRoute
  '/_authenticated/candidates/': typeof AuthenticatedCandidatesIndexRoute
  '/_authenticated/changelog/': typeof AuthenticatedChangelogIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/company-chat/': typeof AuthenticatedCompanyChatIndexRoute
  '/_authenticated/company-jobs/': typeof AuthenticatedCompanyJobsIndexRoute
  '/_authenticated/evaluation-prompt-creation/': typeof AuthenticatedEvaluationPromptCreationIndexRoute
  '/_authenticated/evaluation-prompts/': typeof AuthenticatedEvaluationPromptsIndexRoute
  '/_authenticated/extruct-companies/': typeof AuthenticatedExtructCompaniesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/job-creation/': typeof AuthenticatedJobCreationIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/lemlist-candidates/': typeof AuthenticatedLemlistCandidatesIndexRoute
  '/_authenticated/lemlist-companies/': typeof AuthenticatedLemlistCompaniesIndexRoute
  '/_authenticated/linkdapi-candidates/': typeof AuthenticatedLinkdapiCandidatesIndexRoute
  '/_authenticated/linkedin-ext-candidates/': typeof AuthenticatedLinkedinExtCandidatesIndexRoute
  '/_authenticated/linkedin-job-list/': typeof AuthenticatedLinkedinJobListIndexRoute
  '/_authenticated/marked-candidates/': typeof AuthenticatedMarkedCandidatesIndexRoute
  '/_authenticated/naukri-candidates/': typeof AuthenticatedNaukriCandidatesIndexRoute
  '/_authenticated/resume-candidates/': typeof AuthenticatedResumeCandidatesIndexRoute
  '/_authenticated/scoring/': typeof AuthenticatedScoringIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/traxcn-companies/': typeof AuthenticatedTraxcnCompaniesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/weekday-candidates/': typeof AuthenticatedWeekdayCandidatesIndexRoute
  '/_authenticated/admin/eval-playground/$sessionId': typeof AuthenticatedAdminEvalPlaygroundSessionIdRoute
  '/_authenticated/admin/eval-playground/history': typeof AuthenticatedAdminEvalPlaygroundHistoryRoute
  '/_authenticated/admin/resume-extraction-playground/$sessionId': typeof AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute
  '/_authenticated/admin/resume-extraction-playground/history': typeof AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute
  '/_authenticated/admin/weekday-searches/$searchId': typeof AuthenticatedAdminWeekdaySearchesSearchIdRoute
  '/_authenticated/evaluation-prompt/$promptId/edit': typeof AuthenticatedEvaluationPromptPromptIdEditRoute
  '/_authenticated/jobs/$jobId/activity': typeof AuthenticatedJobsJobIdActivityRoute
  '/_authenticated/jobs/$jobId/candidates': typeof AuthenticatedJobsJobIdCandidatesRoute
  '/_authenticated/jobs/$jobId/edit': typeof AuthenticatedJobsJobIdEditRoute
  '/_authenticated/jobs/$jobId/evaluations': typeof AuthenticatedJobsJobIdEvaluationsRoute
  '/_authenticated/jobs/$jobId/scoring': typeof AuthenticatedJobsJobIdScoringRoute
  '/_authenticated/linkedin-job-list/$linkedinJobId/applicants': typeof AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute
  '/_authenticated/linkedin/sales-navigator/builder': typeof AuthenticatedLinkedinSalesNavigatorBuilderRoute
  '/_authenticated/linkedin/sales-navigator/new': typeof AuthenticatedLinkedinSalesNavigatorNewRoute
  '/_authenticated/scoring/$conversationId/diff': typeof AuthenticatedScoringConversationIdDiffRoute
  '/_authenticated/scoring/$conversationId/evaluate': typeof AuthenticatedScoringConversationIdEvaluateRoute
  '/_authenticated/scoring/$conversationId/view': typeof AuthenticatedScoringConversationIdViewRoute
  '/_authenticated/admin/eval-playground/': typeof AuthenticatedAdminEvalPlaygroundIndexRoute
  '/_authenticated/admin/resume-extraction-playground/': typeof AuthenticatedAdminResumeExtractionPlaygroundIndexRoute
  '/_authenticated/admin/weekday-searches/': typeof AuthenticatedAdminWeekdaySearchesIndexRoute
  '/_authenticated/candidate-chat/$conversationId/': typeof AuthenticatedCandidateChatConversationIdIndexRoute
  '/_authenticated/candidates/$uid/': typeof AuthenticatedCandidatesUidIndexRoute
  '/_authenticated/companies/$uid/': typeof AuthenticatedCompaniesUidIndexRoute
  '/_authenticated/company-chat/$conversationId/': typeof AuthenticatedCompanyChatConversationIdIndexRoute
  '/_authenticated/company-jobs/$jobId/': typeof AuthenticatedCompanyJobsJobIdIndexRoute
  '/_authenticated/company-jobs/marked/': typeof AuthenticatedCompanyJobsMarkedIndexRoute
  '/_authenticated/company-jobs/tracxn/': typeof AuthenticatedCompanyJobsTracxnIndexRoute
  '/_authenticated/hirist/jobs/': typeof AuthenticatedHiristJobsIndexRoute
  '/_authenticated/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexRoute
  '/_authenticated/linkedin/candidates/': typeof AuthenticatedLinkedinCandidatesIndexRoute
  '/_authenticated/linkedin/sales-navigator/': typeof AuthenticatedLinkedinSalesNavigatorIndexRoute
  '/_authenticated/naukri-candidates/$id/': typeof AuthenticatedNaukriCandidatesIdIndexRoute
  '/_authenticated/scoring/$conversationId/': typeof AuthenticatedScoringConversationIdIndexRoute
  '/_authenticated/traxcn-companies/$id/': typeof AuthenticatedTraxcnCompaniesIdIndexRoute
  '/_authenticated/jobs/$jobId/sources/$sourceId': typeof AuthenticatedJobsJobIdSourcesSourceIdRoute
  '/_authenticated/hirist/jobs/$jobId/': typeof AuthenticatedHiristJobsJobIdIndexRoute
  '/_authenticated/jobs/$jobId/sources/': typeof AuthenticatedJobsJobIdSourcesIndexRoute
  '/_authenticated/linkedin/candidates/$username/': typeof AuthenticatedLinkedinCandidatesUsernameIndexRoute
  '/_authenticated/linkedin/sales-navigator/$jobId/': typeof AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clerk'
    | '/privacy'
    | '/admin'
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/admin/weekday-searches'
    | '/jobs/$jobId'
    | '/admin/betterenrich'
    | '/admin/company-enrichment'
    | '/admin/company-enrichment-lite'
    | '/admin/company-experiences'
    | '/admin/company-sheet'
    | '/admin/copilot'
    | '/admin/copilot-chat'
    | '/admin/cost'
    | '/admin/error-logs'
    | '/admin/evaluation-jobs'
    | '/admin/experience-extraction'
    | '/admin/extruct-lookup'
    | '/admin/extruct-similar'
    | '/admin/extruct-similar-history'
    | '/admin/gemini-playground'
    | '/admin/jobs-playground'
    | '/admin/lemlist-company-lookup'
    | '/admin/lemlist-playground'
    | '/admin/pipeline-runs'
    | '/admin/profile-downloads'
    | '/admin/settings'
    | '/admin/signalhire-playground'
    | '/admin/weekday-companies'
    | '/admin/weekday-credentials'
    | '/admin/weekday-enrich'
    | '/admin/weekday-playground'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/extruct'
    | '/settings/hirist'
    | '/settings/linkedin'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/admin/'
    | '/apollo-companies'
    | '/apps'
    | '/candidate-chat'
    | '/candidates'
    | '/changelog'
    | '/chats'
    | '/companies'
    | '/company-chat'
    | '/company-jobs'
    | '/evaluation-prompt-creation'
    | '/evaluation-prompts'
    | '/extruct-companies'
    | '/help-center'
    | '/job-creation'
    | '/jobs'
    | '/lemlist-candidates'
    | '/lemlist-companies'
    | '/linkdapi-candidates'
    | '/linkedin-ext-candidates'
    | '/linkedin-job-list'
    | '/marked-candidates'
    | '/naukri-candidates'
    | '/resume-candidates'
    | '/scoring'
    | '/settings/'
    | '/tasks'
    | '/traxcn-companies'
    | '/users'
    | '/weekday-candidates'
    | '/admin/eval-playground/$sessionId'
    | '/admin/eval-playground/history'
    | '/admin/resume-extraction-playground/$sessionId'
    | '/admin/resume-extraction-playground/history'
    | '/admin/weekday-searches/$searchId'
    | '/evaluation-prompt/$promptId/edit'
    | '/jobs/$jobId/activity'
    | '/jobs/$jobId/candidates'
    | '/jobs/$jobId/edit'
    | '/jobs/$jobId/evaluations'
    | '/jobs/$jobId/scoring'
    | '/linkedin-job-list/$linkedinJobId/applicants'
    | '/linkedin/sales-navigator/builder'
    | '/linkedin/sales-navigator/new'
    | '/scoring/$conversationId/diff'
    | '/scoring/$conversationId/evaluate'
    | '/scoring/$conversationId/view'
    | '/admin/eval-playground'
    | '/admin/resume-extraction-playground'
    | '/admin/weekday-searches/'
    | '/candidate-chat/$conversationId'
    | '/candidates/$uid'
    | '/companies/$uid'
    | '/company-chat/$conversationId'
    | '/company-jobs/$jobId'
    | '/company-jobs/marked'
    | '/company-jobs/tracxn'
    | '/hirist/jobs'
    | '/jobs/$jobId/'
    | '/linkedin/candidates'
    | '/linkedin/sales-navigator'
    | '/naukri-candidates/$id'
    | '/scoring/$conversationId'
    | '/traxcn-companies/$id'
    | '/jobs/$jobId/sources/$sourceId'
    | '/hirist/jobs/$jobId'
    | '/jobs/$jobId/sources'
    | '/linkedin/candidates/$username'
    | '/linkedin/sales-navigator/$jobId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/privacy'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/admin/betterenrich'
    | '/admin/company-enrichment'
    | '/admin/company-enrichment-lite'
    | '/admin/company-experiences'
    | '/admin/company-sheet'
    | '/admin/copilot'
    | '/admin/copilot-chat'
    | '/admin/cost'
    | '/admin/error-logs'
    | '/admin/evaluation-jobs'
    | '/admin/experience-extraction'
    | '/admin/extruct-lookup'
    | '/admin/extruct-similar'
    | '/admin/extruct-similar-history'
    | '/admin/gemini-playground'
    | '/admin/jobs-playground'
    | '/admin/lemlist-company-lookup'
    | '/admin/lemlist-playground'
    | '/admin/pipeline-runs'
    | '/admin/profile-downloads'
    | '/admin/settings'
    | '/admin/signalhire-playground'
    | '/admin/weekday-companies'
    | '/admin/weekday-credentials'
    | '/admin/weekday-enrich'
    | '/admin/weekday-playground'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/extruct'
    | '/settings/hirist'
    | '/settings/linkedin'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/admin'
    | '/apollo-companies'
    | '/apps'
    | '/candidate-chat'
    | '/candidates'
    | '/changelog'
    | '/chats'
    | '/companies'
    | '/company-chat'
    | '/company-jobs'
    | '/evaluation-prompt-creation'
    | '/evaluation-prompts'
    | '/extruct-companies'
    | '/help-center'
    | '/job-creation'
    | '/jobs'
    | '/lemlist-candidates'
    | '/lemlist-companies'
    | '/linkdapi-candidates'
    | '/linkedin-ext-candidates'
    | '/linkedin-job-list'
    | '/marked-candidates'
    | '/naukri-candidates'
    | '/resume-candidates'
    | '/scoring'
    | '/settings'
    | '/tasks'
    | '/traxcn-companies'
    | '/users'
    | '/weekday-candidates'
    | '/admin/eval-playground/$sessionId'
    | '/admin/eval-playground/history'
    | '/admin/resume-extraction-playground/$sessionId'
    | '/admin/resume-extraction-playground/history'
    | '/admin/weekday-searches/$searchId'
    | '/evaluation-prompt/$promptId/edit'
    | '/jobs/$jobId/activity'
    | '/jobs/$jobId/candidates'
    | '/jobs/$jobId/edit'
    | '/jobs/$jobId/evaluations'
    | '/jobs/$jobId/scoring'
    | '/linkedin-job-list/$linkedinJobId/applicants'
    | '/linkedin/sales-navigator/builder'
    | '/linkedin/sales-navigator/new'
    | '/scoring/$conversationId/diff'
    | '/scoring/$conversationId/evaluate'
    | '/scoring/$conversationId/view'
    | '/admin/eval-playground'
    | '/admin/resume-extraction-playground'
    | '/admin/weekday-searches'
    | '/candidate-chat/$conversationId'
    | '/candidates/$uid'
    | '/companies/$uid'
    | '/company-chat/$conversationId'
    | '/company-jobs/$jobId'
    | '/company-jobs/marked'
    | '/company-jobs/tracxn'
    | '/hirist/jobs'
    | '/jobs/$jobId'
    | '/linkedin/candidates'
    | '/linkedin/sales-navigator'
    | '/naukri-candidates/$id'
    | '/scoring/$conversationId'
    | '/traxcn-companies/$id'
    | '/jobs/$jobId/sources/$sourceId'
    | '/hirist/jobs/$jobId'
    | '/jobs/$jobId/sources'
    | '/linkedin/candidates/$username'
    | '/linkedin/sales-navigator/$jobId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/privacy'
    | '/_authenticated/admin'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/admin/weekday-searches'
    | '/_authenticated/jobs/$jobId'
    | '/_authenticated/admin/betterenrich'
    | '/_authenticated/admin/company-enrichment'
    | '/_authenticated/admin/company-enrichment-lite'
    | '/_authenticated/admin/company-experiences'
    | '/_authenticated/admin/company-sheet'
    | '/_authenticated/admin/copilot'
    | '/_authenticated/admin/copilot-chat'
    | '/_authenticated/admin/cost'
    | '/_authenticated/admin/error-logs'
    | '/_authenticated/admin/evaluation-jobs'
    | '/_authenticated/admin/experience-extraction'
    | '/_authenticated/admin/extruct-lookup'
    | '/_authenticated/admin/extruct-similar'
    | '/_authenticated/admin/extruct-similar-history'
    | '/_authenticated/admin/gemini-playground'
    | '/_authenticated/admin/jobs-playground'
    | '/_authenticated/admin/lemlist-company-lookup'
    | '/_authenticated/admin/lemlist-playground'
    | '/_authenticated/admin/pipeline-runs'
    | '/_authenticated/admin/profile-downloads'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/signalhire-playground'
    | '/_authenticated/admin/weekday-companies'
    | '/_authenticated/admin/weekday-credentials'
    | '/_authenticated/admin/weekday-enrich'
    | '/_authenticated/admin/weekday-playground'
    | '/_authenticated/errors/$error'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/extruct'
    | '/_authenticated/settings/hirist'
    | '/_authenticated/settings/linkedin'
    | '/_authenticated/settings/notifications'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/admin/'
    | '/_authenticated/apollo-companies/'
    | '/_authenticated/apps/'
    | '/_authenticated/candidate-chat/'
    | '/_authenticated/candidates/'
    | '/_authenticated/changelog/'
    | '/_authenticated/chats/'
    | '/_authenticated/companies/'
    | '/_authenticated/company-chat/'
    | '/_authenticated/company-jobs/'
    | '/_authenticated/evaluation-prompt-creation/'
    | '/_authenticated/evaluation-prompts/'
    | '/_authenticated/extruct-companies/'
    | '/_authenticated/help-center/'
    | '/_authenticated/job-creation/'
    | '/_authenticated/jobs/'
    | '/_authenticated/lemlist-candidates/'
    | '/_authenticated/lemlist-companies/'
    | '/_authenticated/linkdapi-candidates/'
    | '/_authenticated/linkedin-ext-candidates/'
    | '/_authenticated/linkedin-job-list/'
    | '/_authenticated/marked-candidates/'
    | '/_authenticated/naukri-candidates/'
    | '/_authenticated/resume-candidates/'
    | '/_authenticated/scoring/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/traxcn-companies/'
    | '/_authenticated/users/'
    | '/_authenticated/weekday-candidates/'
    | '/_authenticated/admin/eval-playground/$sessionId'
    | '/_authenticated/admin/eval-playground/history'
    | '/_authenticated/admin/resume-extraction-playground/$sessionId'
    | '/_authenticated/admin/resume-extraction-playground/history'
    | '/_authenticated/admin/weekday-searches/$searchId'
    | '/_authenticated/evaluation-prompt/$promptId/edit'
    | '/_authenticated/jobs/$jobId/activity'
    | '/_authenticated/jobs/$jobId/candidates'
    | '/_authenticated/jobs/$jobId/edit'
    | '/_authenticated/jobs/$jobId/evaluations'
    | '/_authenticated/jobs/$jobId/scoring'
    | '/_authenticated/linkedin-job-list/$linkedinJobId/applicants'
    | '/_authenticated/linkedin/sales-navigator/builder'
    | '/_authenticated/linkedin/sales-navigator/new'
    | '/_authenticated/scoring/$conversationId/diff'
    | '/_authenticated/scoring/$conversationId/evaluate'
    | '/_authenticated/scoring/$conversationId/view'
    | '/_authenticated/admin/eval-playground/'
    | '/_authenticated/admin/resume-extraction-playground/'
    | '/_authenticated/admin/weekday-searches/'
    | '/_authenticated/candidate-chat/$conversationId/'
    | '/_authenticated/candidates/$uid/'
    | '/_authenticated/companies/$uid/'
    | '/_authenticated/company-chat/$conversationId/'
    | '/_authenticated/company-jobs/$jobId/'
    | '/_authenticated/company-jobs/marked/'
    | '/_authenticated/company-jobs/tracxn/'
    | '/_authenticated/hirist/jobs/'
    | '/_authenticated/jobs/$jobId/'
    | '/_authenticated/linkedin/candidates/'
    | '/_authenticated/linkedin/sales-navigator/'
    | '/_authenticated/naukri-candidates/$id/'
    | '/_authenticated/scoring/$conversationId/'
    | '/_authenticated/traxcn-companies/$id/'
    | '/_authenticated/jobs/$jobId/sources/$sourceId'
    | '/_authenticated/hirist/jobs/$jobId/'
    | '/_authenticated/jobs/$jobId/sources/'
    | '/_authenticated/linkedin/candidates/$username/'
    | '/_authenticated/linkedin/sales-navigator/$jobId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/weekday-candidates/': {
      id: '/_authenticated/weekday-candidates/'
      path: '/weekday-candidates'
      fullPath: '/weekday-candidates'
      preLoaderRoute: typeof AuthenticatedWeekdayCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/traxcn-companies/': {
      id: '/_authenticated/traxcn-companies/'
      path: '/traxcn-companies'
      fullPath: '/traxcn-companies'
      preLoaderRoute: typeof AuthenticatedTraxcnCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/scoring/': {
      id: '/_authenticated/scoring/'
      path: '/scoring'
      fullPath: '/scoring'
      preLoaderRoute: typeof AuthenticatedScoringIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resume-candidates/': {
      id: '/_authenticated/resume-candidates/'
      path: '/resume-candidates'
      fullPath: '/resume-candidates'
      preLoaderRoute: typeof AuthenticatedResumeCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/naukri-candidates/': {
      id: '/_authenticated/naukri-candidates/'
      path: '/naukri-candidates'
      fullPath: '/naukri-candidates'
      preLoaderRoute: typeof AuthenticatedNaukriCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marked-candidates/': {
      id: '/_authenticated/marked-candidates/'
      path: '/marked-candidates'
      fullPath: '/marked-candidates'
      preLoaderRoute: typeof AuthenticatedMarkedCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin-job-list/': {
      id: '/_authenticated/linkedin-job-list/'
      path: '/linkedin-job-list'
      fullPath: '/linkedin-job-list'
      preLoaderRoute: typeof AuthenticatedLinkedinJobListIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin-ext-candidates/': {
      id: '/_authenticated/linkedin-ext-candidates/'
      path: '/linkedin-ext-candidates'
      fullPath: '/linkedin-ext-candidates'
      preLoaderRoute: typeof AuthenticatedLinkedinExtCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkdapi-candidates/': {
      id: '/_authenticated/linkdapi-candidates/'
      path: '/linkdapi-candidates'
      fullPath: '/linkdapi-candidates'
      preLoaderRoute: typeof AuthenticatedLinkdapiCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lemlist-companies/': {
      id: '/_authenticated/lemlist-companies/'
      path: '/lemlist-companies'
      fullPath: '/lemlist-companies'
      preLoaderRoute: typeof AuthenticatedLemlistCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lemlist-candidates/': {
      id: '/_authenticated/lemlist-candidates/'
      path: '/lemlist-candidates'
      fullPath: '/lemlist-candidates'
      preLoaderRoute: typeof AuthenticatedLemlistCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/job-creation/': {
      id: '/_authenticated/job-creation/'
      path: '/job-creation'
      fullPath: '/job-creation'
      preLoaderRoute: typeof AuthenticatedJobCreationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/extruct-companies/': {
      id: '/_authenticated/extruct-companies/'
      path: '/extruct-companies'
      fullPath: '/extruct-companies'
      preLoaderRoute: typeof AuthenticatedExtructCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/evaluation-prompts/': {
      id: '/_authenticated/evaluation-prompts/'
      path: '/evaluation-prompts'
      fullPath: '/evaluation-prompts'
      preLoaderRoute: typeof AuthenticatedEvaluationPromptsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/evaluation-prompt-creation/': {
      id: '/_authenticated/evaluation-prompt-creation/'
      path: '/evaluation-prompt-creation'
      fullPath: '/evaluation-prompt-creation'
      preLoaderRoute: typeof AuthenticatedEvaluationPromptCreationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-jobs/': {
      id: '/_authenticated/company-jobs/'
      path: '/company-jobs'
      fullPath: '/company-jobs'
      preLoaderRoute: typeof AuthenticatedCompanyJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-chat/': {
      id: '/_authenticated/company-chat/'
      path: '/company-chat'
      fullPath: '/company-chat'
      preLoaderRoute: typeof AuthenticatedCompanyChatIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/changelog/': {
      id: '/_authenticated/changelog/'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AuthenticatedChangelogIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidates/': {
      id: '/_authenticated/candidates/'
      path: '/candidates'
      fullPath: '/candidates'
      preLoaderRoute: typeof AuthenticatedCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidate-chat/': {
      id: '/_authenticated/candidate-chat/'
      path: '/candidate-chat'
      fullPath: '/candidate-chat'
      preLoaderRoute: typeof AuthenticatedCandidateChatIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apollo-companies/': {
      id: '/_authenticated/apollo-companies/'
      path: '/apollo-companies'
      fullPath: '/apollo-companies'
      preLoaderRoute: typeof AuthenticatedApolloCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/linkedin': {
      id: '/_authenticated/settings/linkedin'
      path: '/linkedin'
      fullPath: '/settings/linkedin'
      preLoaderRoute: typeof AuthenticatedSettingsLinkedinRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/hirist': {
      id: '/_authenticated/settings/hirist'
      path: '/hirist'
      fullPath: '/settings/hirist'
      preLoaderRoute: typeof AuthenticatedSettingsHiristRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/extruct': {
      id: '/_authenticated/settings/extruct'
      path: '/extruct'
      fullPath: '/settings/extruct'
      preLoaderRoute: typeof AuthenticatedSettingsExtructRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/weekday-playground': {
      id: '/_authenticated/admin/weekday-playground'
      path: '/weekday-playground'
      fullPath: '/admin/weekday-playground'
      preLoaderRoute: typeof AuthenticatedAdminWeekdayPlaygroundRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/weekday-enrich': {
      id: '/_authenticated/admin/weekday-enrich'
      path: '/weekday-enrich'
      fullPath: '/admin/weekday-enrich'
      preLoaderRoute: typeof AuthenticatedAdminWeekdayEnrichRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/weekday-credentials': {
      id: '/_authenticated/admin/weekday-credentials'
      path: '/weekday-credentials'
      fullPath: '/admin/weekday-credentials'
      preLoaderRoute: typeof AuthenticatedAdminWeekdayCredentialsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/weekday-companies': {
      id: '/_authenticated/admin/weekday-companies'
      path: '/weekday-companies'
      fullPath: '/admin/weekday-companies'
      preLoaderRoute: typeof AuthenticatedAdminWeekdayCompaniesRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/signalhire-playground': {
      id: '/_authenticated/admin/signalhire-playground'
      path: '/signalhire-playground'
      fullPath: '/admin/signalhire-playground'
      preLoaderRoute: typeof AuthenticatedAdminSignalhirePlaygroundRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/profile-downloads': {
      id: '/_authenticated/admin/profile-downloads'
      path: '/profile-downloads'
      fullPath: '/admin/profile-downloads'
      preLoaderRoute: typeof AuthenticatedAdminProfileDownloadsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/pipeline-runs': {
      id: '/_authenticated/admin/pipeline-runs'
      path: '/pipeline-runs'
      fullPath: '/admin/pipeline-runs'
      preLoaderRoute: typeof AuthenticatedAdminPipelineRunsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/lemlist-playground': {
      id: '/_authenticated/admin/lemlist-playground'
      path: '/lemlist-playground'
      fullPath: '/admin/lemlist-playground'
      preLoaderRoute: typeof AuthenticatedAdminLemlistPlaygroundRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/lemlist-company-lookup': {
      id: '/_authenticated/admin/lemlist-company-lookup'
      path: '/lemlist-company-lookup'
      fullPath: '/admin/lemlist-company-lookup'
      preLoaderRoute: typeof AuthenticatedAdminLemlistCompanyLookupRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/jobs-playground': {
      id: '/_authenticated/admin/jobs-playground'
      path: '/jobs-playground'
      fullPath: '/admin/jobs-playground'
      preLoaderRoute: typeof AuthenticatedAdminJobsPlaygroundRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/gemini-playground': {
      id: '/_authenticated/admin/gemini-playground'
      path: '/gemini-playground'
      fullPath: '/admin/gemini-playground'
      preLoaderRoute: typeof AuthenticatedAdminGeminiPlaygroundRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/extruct-similar-history': {
      id: '/_authenticated/admin/extruct-similar-history'
      path: '/extruct-similar-history'
      fullPath: '/admin/extruct-similar-history'
      preLoaderRoute: typeof AuthenticatedAdminExtructSimilarHistoryRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/extruct-similar': {
      id: '/_authenticated/admin/extruct-similar'
      path: '/extruct-similar'
      fullPath: '/admin/extruct-similar'
      preLoaderRoute: typeof AuthenticatedAdminExtructSimilarRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/extruct-lookup': {
      id: '/_authenticated/admin/extruct-lookup'
      path: '/extruct-lookup'
      fullPath: '/admin/extruct-lookup'
      preLoaderRoute: typeof AuthenticatedAdminExtructLookupRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/experience-extraction': {
      id: '/_authenticated/admin/experience-extraction'
      path: '/experience-extraction'
      fullPath: '/admin/experience-extraction'
      preLoaderRoute: typeof AuthenticatedAdminExperienceExtractionRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/evaluation-jobs': {
      id: '/_authenticated/admin/evaluation-jobs'
      path: '/evaluation-jobs'
      fullPath: '/admin/evaluation-jobs'
      preLoaderRoute: typeof AuthenticatedAdminEvaluationJobsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/error-logs': {
      id: '/_authenticated/admin/error-logs'
      path: '/error-logs'
      fullPath: '/admin/error-logs'
      preLoaderRoute: typeof AuthenticatedAdminErrorLogsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cost': {
      id: '/_authenticated/admin/cost'
      path: '/cost'
      fullPath: '/admin/cost'
      preLoaderRoute: typeof AuthenticatedAdminCostRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/copilot-chat': {
      id: '/_authenticated/admin/copilot-chat'
      path: '/copilot-chat'
      fullPath: '/admin/copilot-chat'
      preLoaderRoute: typeof AuthenticatedAdminCopilotChatRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/copilot': {
      id: '/_authenticated/admin/copilot'
      path: '/copilot'
      fullPath: '/admin/copilot'
      preLoaderRoute: typeof AuthenticatedAdminCopilotRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/company-sheet': {
      id: '/_authenticated/admin/company-sheet'
      path: '/company-sheet'
      fullPath: '/admin/company-sheet'
      preLoaderRoute: typeof AuthenticatedAdminCompanySheetRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/company-experiences': {
      id: '/_authenticated/admin/company-experiences'
      path: '/company-experiences'
      fullPath: '/admin/company-experiences'
      preLoaderRoute: typeof AuthenticatedAdminCompanyExperiencesRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/company-enrichment-lite': {
      id: '/_authenticated/admin/company-enrichment-lite'
      path: '/company-enrichment-lite'
      fullPath: '/admin/company-enrichment-lite'
      preLoaderRoute: typeof AuthenticatedAdminCompanyEnrichmentLiteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/company-enrichment': {
      id: '/_authenticated/admin/company-enrichment'
      path: '/company-enrichment'
      fullPath: '/admin/company-enrichment'
      preLoaderRoute: typeof AuthenticatedAdminCompanyEnrichmentRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/betterenrich': {
      id: '/_authenticated/admin/betterenrich'
      path: '/betterenrich'
      fullPath: '/admin/betterenrich'
      preLoaderRoute: typeof AuthenticatedAdminBetterenrichRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/jobs/$jobId': {
      id: '/_authenticated/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/weekday-searches': {
      id: '/_authenticated/admin/weekday-searches'
      path: '/weekday-searches'
      fullPath: '/admin/weekday-searches'
      preLoaderRoute: typeof AuthenticatedAdminWeekdaySearchesRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/traxcn-companies/$id/': {
      id: '/_authenticated/traxcn-companies/$id/'
      path: '/traxcn-companies/$id'
      fullPath: '/traxcn-companies/$id'
      preLoaderRoute: typeof AuthenticatedTraxcnCompaniesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scoring/$conversationId/': {
      id: '/_authenticated/scoring/$conversationId/'
      path: '/scoring/$conversationId'
      fullPath: '/scoring/$conversationId'
      preLoaderRoute: typeof AuthenticatedScoringConversationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/naukri-candidates/$id/': {
      id: '/_authenticated/naukri-candidates/$id/'
      path: '/naukri-candidates/$id'
      fullPath: '/naukri-candidates/$id'
      preLoaderRoute: typeof AuthenticatedNaukriCandidatesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin/sales-navigator/': {
      id: '/_authenticated/linkedin/sales-navigator/'
      path: '/linkedin/sales-navigator'
      fullPath: '/linkedin/sales-navigator'
      preLoaderRoute: typeof AuthenticatedLinkedinSalesNavigatorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin/candidates/': {
      id: '/_authenticated/linkedin/candidates/'
      path: '/linkedin/candidates'
      fullPath: '/linkedin/candidates'
      preLoaderRoute: typeof AuthenticatedLinkedinCandidatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/': {
      id: '/_authenticated/jobs/$jobId/'
      path: '/'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AuthenticatedJobsJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/hirist/jobs/': {
      id: '/_authenticated/hirist/jobs/'
      path: '/hirist/jobs'
      fullPath: '/hirist/jobs'
      preLoaderRoute: typeof AuthenticatedHiristJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-jobs/tracxn/': {
      id: '/_authenticated/company-jobs/tracxn/'
      path: '/company-jobs/tracxn'
      fullPath: '/company-jobs/tracxn'
      preLoaderRoute: typeof AuthenticatedCompanyJobsTracxnIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-jobs/marked/': {
      id: '/_authenticated/company-jobs/marked/'
      path: '/company-jobs/marked'
      fullPath: '/company-jobs/marked'
      preLoaderRoute: typeof AuthenticatedCompanyJobsMarkedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-jobs/$jobId/': {
      id: '/_authenticated/company-jobs/$jobId/'
      path: '/company-jobs/$jobId'
      fullPath: '/company-jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedCompanyJobsJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-chat/$conversationId/': {
      id: '/_authenticated/company-chat/$conversationId/'
      path: '/company-chat/$conversationId'
      fullPath: '/company-chat/$conversationId'
      preLoaderRoute: typeof AuthenticatedCompanyChatConversationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/$uid/': {
      id: '/_authenticated/companies/$uid/'
      path: '/companies/$uid'
      fullPath: '/companies/$uid'
      preLoaderRoute: typeof AuthenticatedCompaniesUidIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidates/$uid/': {
      id: '/_authenticated/candidates/$uid/'
      path: '/candidates/$uid'
      fullPath: '/candidates/$uid'
      preLoaderRoute: typeof AuthenticatedCandidatesUidIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidate-chat/$conversationId/': {
      id: '/_authenticated/candidate-chat/$conversationId/'
      path: '/candidate-chat/$conversationId'
      fullPath: '/candidate-chat/$conversationId'
      preLoaderRoute: typeof AuthenticatedCandidateChatConversationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/weekday-searches/': {
      id: '/_authenticated/admin/weekday-searches/'
      path: '/'
      fullPath: '/admin/weekday-searches/'
      preLoaderRoute: typeof AuthenticatedAdminWeekdaySearchesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminWeekdaySearchesRouteRoute
    }
    '/_authenticated/admin/resume-extraction-playground/': {
      id: '/_authenticated/admin/resume-extraction-playground/'
      path: '/resume-extraction-playground'
      fullPath: '/admin/resume-extraction-playground'
      preLoaderRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/eval-playground/': {
      id: '/_authenticated/admin/eval-playground/'
      path: '/eval-playground'
      fullPath: '/admin/eval-playground'
      preLoaderRoute: typeof AuthenticatedAdminEvalPlaygroundIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/scoring/$conversationId/view': {
      id: '/_authenticated/scoring/$conversationId/view'
      path: '/scoring/$conversationId/view'
      fullPath: '/scoring/$conversationId/view'
      preLoaderRoute: typeof AuthenticatedScoringConversationIdViewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scoring/$conversationId/evaluate': {
      id: '/_authenticated/scoring/$conversationId/evaluate'
      path: '/scoring/$conversationId/evaluate'
      fullPath: '/scoring/$conversationId/evaluate'
      preLoaderRoute: typeof AuthenticatedScoringConversationIdEvaluateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scoring/$conversationId/diff': {
      id: '/_authenticated/scoring/$conversationId/diff'
      path: '/scoring/$conversationId/diff'
      fullPath: '/scoring/$conversationId/diff'
      preLoaderRoute: typeof AuthenticatedScoringConversationIdDiffRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin/sales-navigator/new': {
      id: '/_authenticated/linkedin/sales-navigator/new'
      path: '/linkedin/sales-navigator/new'
      fullPath: '/linkedin/sales-navigator/new'
      preLoaderRoute: typeof AuthenticatedLinkedinSalesNavigatorNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin/sales-navigator/builder': {
      id: '/_authenticated/linkedin/sales-navigator/builder'
      path: '/linkedin/sales-navigator/builder'
      fullPath: '/linkedin/sales-navigator/builder'
      preLoaderRoute: typeof AuthenticatedLinkedinSalesNavigatorBuilderRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin-job-list/$linkedinJobId/applicants': {
      id: '/_authenticated/linkedin-job-list/$linkedinJobId/applicants'
      path: '/linkedin-job-list/$linkedinJobId/applicants'
      fullPath: '/linkedin-job-list/$linkedinJobId/applicants'
      preLoaderRoute: typeof AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/scoring': {
      id: '/_authenticated/jobs/$jobId/scoring'
      path: '/scoring'
      fullPath: '/jobs/$jobId/scoring'
      preLoaderRoute: typeof AuthenticatedJobsJobIdScoringRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/evaluations': {
      id: '/_authenticated/jobs/$jobId/evaluations'
      path: '/evaluations'
      fullPath: '/jobs/$jobId/evaluations'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEvaluationsRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/edit': {
      id: '/_authenticated/jobs/$jobId/edit'
      path: '/edit'
      fullPath: '/jobs/$jobId/edit'
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/candidates': {
      id: '/_authenticated/jobs/$jobId/candidates'
      path: '/candidates'
      fullPath: '/jobs/$jobId/candidates'
      preLoaderRoute: typeof AuthenticatedJobsJobIdCandidatesRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/activity': {
      id: '/_authenticated/jobs/$jobId/activity'
      path: '/activity'
      fullPath: '/jobs/$jobId/activity'
      preLoaderRoute: typeof AuthenticatedJobsJobIdActivityRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/evaluation-prompt/$promptId/edit': {
      id: '/_authenticated/evaluation-prompt/$promptId/edit'
      path: '/evaluation-prompt/$promptId/edit'
      fullPath: '/evaluation-prompt/$promptId/edit'
      preLoaderRoute: typeof AuthenticatedEvaluationPromptPromptIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/weekday-searches/$searchId': {
      id: '/_authenticated/admin/weekday-searches/$searchId'
      path: '/$searchId'
      fullPath: '/admin/weekday-searches/$searchId'
      preLoaderRoute: typeof AuthenticatedAdminWeekdaySearchesSearchIdRouteImport
      parentRoute: typeof AuthenticatedAdminWeekdaySearchesRouteRoute
    }
    '/_authenticated/admin/resume-extraction-playground/history': {
      id: '/_authenticated/admin/resume-extraction-playground/history'
      path: '/resume-extraction-playground/history'
      fullPath: '/admin/resume-extraction-playground/history'
      preLoaderRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundHistoryRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/resume-extraction-playground/$sessionId': {
      id: '/_authenticated/admin/resume-extraction-playground/$sessionId'
      path: '/resume-extraction-playground/$sessionId'
      fullPath: '/admin/resume-extraction-playground/$sessionId'
      preLoaderRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundSessionIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/eval-playground/history': {
      id: '/_authenticated/admin/eval-playground/history'
      path: '/eval-playground/history'
      fullPath: '/admin/eval-playground/history'
      preLoaderRoute: typeof AuthenticatedAdminEvalPlaygroundHistoryRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/eval-playground/$sessionId': {
      id: '/_authenticated/admin/eval-playground/$sessionId'
      path: '/eval-playground/$sessionId'
      fullPath: '/admin/eval-playground/$sessionId'
      preLoaderRoute: typeof AuthenticatedAdminEvalPlaygroundSessionIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/linkedin/sales-navigator/$jobId/': {
      id: '/_authenticated/linkedin/sales-navigator/$jobId/'
      path: '/linkedin/sales-navigator/$jobId'
      fullPath: '/linkedin/sales-navigator/$jobId'
      preLoaderRoute: typeof AuthenticatedLinkedinSalesNavigatorJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/linkedin/candidates/$username/': {
      id: '/_authenticated/linkedin/candidates/$username/'
      path: '/linkedin/candidates/$username'
      fullPath: '/linkedin/candidates/$username'
      preLoaderRoute: typeof AuthenticatedLinkedinCandidatesUsernameIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/sources/': {
      id: '/_authenticated/jobs/$jobId/sources/'
      path: '/sources'
      fullPath: '/jobs/$jobId/sources'
      preLoaderRoute: typeof AuthenticatedJobsJobIdSourcesIndexRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/hirist/jobs/$jobId/': {
      id: '/_authenticated/hirist/jobs/$jobId/'
      path: '/hirist/jobs/$jobId'
      fullPath: '/hirist/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedHiristJobsJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/sources/$sourceId': {
      id: '/_authenticated/jobs/$jobId/sources/$sourceId'
      path: '/sources/$sourceId'
      fullPath: '/jobs/$jobId/sources/$sourceId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdSourcesSourceIdRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
  }
}

interface AuthenticatedAdminWeekdaySearchesRouteRouteChildren {
  AuthenticatedAdminWeekdaySearchesSearchIdRoute: typeof AuthenticatedAdminWeekdaySearchesSearchIdRoute
  AuthenticatedAdminWeekdaySearchesIndexRoute: typeof AuthenticatedAdminWeekdaySearchesIndexRoute
}

const AuthenticatedAdminWeekdaySearchesRouteRouteChildren: AuthenticatedAdminWeekdaySearchesRouteRouteChildren =
  {
    AuthenticatedAdminWeekdaySearchesSearchIdRoute:
      AuthenticatedAdminWeekdaySearchesSearchIdRoute,
    AuthenticatedAdminWeekdaySearchesIndexRoute:
      AuthenticatedAdminWeekdaySearchesIndexRoute,
  }

const AuthenticatedAdminWeekdaySearchesRouteRouteWithChildren =
  AuthenticatedAdminWeekdaySearchesRouteRoute._addFileChildren(
    AuthenticatedAdminWeekdaySearchesRouteRouteChildren,
  )

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminWeekdaySearchesRouteRoute: typeof AuthenticatedAdminWeekdaySearchesRouteRouteWithChildren
  AuthenticatedAdminBetterenrichRoute: typeof AuthenticatedAdminBetterenrichRoute
  AuthenticatedAdminCompanyEnrichmentRoute: typeof AuthenticatedAdminCompanyEnrichmentRoute
  AuthenticatedAdminCompanyEnrichmentLiteRoute: typeof AuthenticatedAdminCompanyEnrichmentLiteRoute
  AuthenticatedAdminCompanyExperiencesRoute: typeof AuthenticatedAdminCompanyExperiencesRoute
  AuthenticatedAdminCompanySheetRoute: typeof AuthenticatedAdminCompanySheetRoute
  AuthenticatedAdminCopilotRoute: typeof AuthenticatedAdminCopilotRoute
  AuthenticatedAdminCopilotChatRoute: typeof AuthenticatedAdminCopilotChatRoute
  AuthenticatedAdminCostRoute: typeof AuthenticatedAdminCostRoute
  AuthenticatedAdminErrorLogsRoute: typeof AuthenticatedAdminErrorLogsRoute
  AuthenticatedAdminEvaluationJobsRoute: typeof AuthenticatedAdminEvaluationJobsRoute
  AuthenticatedAdminExperienceExtractionRoute: typeof AuthenticatedAdminExperienceExtractionRoute
  AuthenticatedAdminExtructLookupRoute: typeof AuthenticatedAdminExtructLookupRoute
  AuthenticatedAdminExtructSimilarRoute: typeof AuthenticatedAdminExtructSimilarRoute
  AuthenticatedAdminExtructSimilarHistoryRoute: typeof AuthenticatedAdminExtructSimilarHistoryRoute
  AuthenticatedAdminGeminiPlaygroundRoute: typeof AuthenticatedAdminGeminiPlaygroundRoute
  AuthenticatedAdminJobsPlaygroundRoute: typeof AuthenticatedAdminJobsPlaygroundRoute
  AuthenticatedAdminLemlistCompanyLookupRoute: typeof AuthenticatedAdminLemlistCompanyLookupRoute
  AuthenticatedAdminLemlistPlaygroundRoute: typeof AuthenticatedAdminLemlistPlaygroundRoute
  AuthenticatedAdminPipelineRunsRoute: typeof AuthenticatedAdminPipelineRunsRoute
  AuthenticatedAdminProfileDownloadsRoute: typeof AuthenticatedAdminProfileDownloadsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminSignalhirePlaygroundRoute: typeof AuthenticatedAdminSignalhirePlaygroundRoute
  AuthenticatedAdminWeekdayCompaniesRoute: typeof AuthenticatedAdminWeekdayCompaniesRoute
  AuthenticatedAdminWeekdayCredentialsRoute: typeof AuthenticatedAdminWeekdayCredentialsRoute
  AuthenticatedAdminWeekdayEnrichRoute: typeof AuthenticatedAdminWeekdayEnrichRoute
  AuthenticatedAdminWeekdayPlaygroundRoute: typeof AuthenticatedAdminWeekdayPlaygroundRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminEvalPlaygroundSessionIdRoute: typeof AuthenticatedAdminEvalPlaygroundSessionIdRoute
  AuthenticatedAdminEvalPlaygroundHistoryRoute: typeof AuthenticatedAdminEvalPlaygroundHistoryRoute
  AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute
  AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute
  AuthenticatedAdminEvalPlaygroundIndexRoute: typeof AuthenticatedAdminEvalPlaygroundIndexRoute
  AuthenticatedAdminResumeExtractionPlaygroundIndexRoute: typeof AuthenticatedAdminResumeExtractionPlaygroundIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminWeekdaySearchesRouteRoute:
      AuthenticatedAdminWeekdaySearchesRouteRouteWithChildren,
    AuthenticatedAdminBetterenrichRoute: AuthenticatedAdminBetterenrichRoute,
    AuthenticatedAdminCompanyEnrichmentRoute:
      AuthenticatedAdminCompanyEnrichmentRoute,
    AuthenticatedAdminCompanyEnrichmentLiteRoute:
      AuthenticatedAdminCompanyEnrichmentLiteRoute,
    AuthenticatedAdminCompanyExperiencesRoute:
      AuthenticatedAdminCompanyExperiencesRoute,
    AuthenticatedAdminCompanySheetRoute: AuthenticatedAdminCompanySheetRoute,
    AuthenticatedAdminCopilotRoute: AuthenticatedAdminCopilotRoute,
    AuthenticatedAdminCopilotChatRoute: AuthenticatedAdminCopilotChatRoute,
    AuthenticatedAdminCostRoute: AuthenticatedAdminCostRoute,
    AuthenticatedAdminErrorLogsRoute: AuthenticatedAdminErrorLogsRoute,
    AuthenticatedAdminEvaluationJobsRoute:
      AuthenticatedAdminEvaluationJobsRoute,
    AuthenticatedAdminExperienceExtractionRoute:
      AuthenticatedAdminExperienceExtractionRoute,
    AuthenticatedAdminExtructLookupRoute: AuthenticatedAdminExtructLookupRoute,
    AuthenticatedAdminExtructSimilarRoute:
      AuthenticatedAdminExtructSimilarRoute,
    AuthenticatedAdminExtructSimilarHistoryRoute:
      AuthenticatedAdminExtructSimilarHistoryRoute,
    AuthenticatedAdminGeminiPlaygroundRoute:
      AuthenticatedAdminGeminiPlaygroundRoute,
    AuthenticatedAdminJobsPlaygroundRoute:
      AuthenticatedAdminJobsPlaygroundRoute,
    AuthenticatedAdminLemlistCompanyLookupRoute:
      AuthenticatedAdminLemlistCompanyLookupRoute,
    AuthenticatedAdminLemlistPlaygroundRoute:
      AuthenticatedAdminLemlistPlaygroundRoute,
    AuthenticatedAdminPipelineRunsRoute: AuthenticatedAdminPipelineRunsRoute,
    AuthenticatedAdminProfileDownloadsRoute:
      AuthenticatedAdminProfileDownloadsRoute,
    AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
    AuthenticatedAdminSignalhirePlaygroundRoute:
      AuthenticatedAdminSignalhirePlaygroundRoute,
    AuthenticatedAdminWeekdayCompaniesRoute:
      AuthenticatedAdminWeekdayCompaniesRoute,
    AuthenticatedAdminWeekdayCredentialsRoute:
      AuthenticatedAdminWeekdayCredentialsRoute,
    AuthenticatedAdminWeekdayEnrichRoute: AuthenticatedAdminWeekdayEnrichRoute,
    AuthenticatedAdminWeekdayPlaygroundRoute:
      AuthenticatedAdminWeekdayPlaygroundRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
    AuthenticatedAdminEvalPlaygroundSessionIdRoute:
      AuthenticatedAdminEvalPlaygroundSessionIdRoute,
    AuthenticatedAdminEvalPlaygroundHistoryRoute:
      AuthenticatedAdminEvalPlaygroundHistoryRoute,
    AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute:
      AuthenticatedAdminResumeExtractionPlaygroundSessionIdRoute,
    AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute:
      AuthenticatedAdminResumeExtractionPlaygroundHistoryRoute,
    AuthenticatedAdminEvalPlaygroundIndexRoute:
      AuthenticatedAdminEvalPlaygroundIndexRoute,
    AuthenticatedAdminResumeExtractionPlaygroundIndexRoute:
      AuthenticatedAdminResumeExtractionPlaygroundIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsExtructRoute: typeof AuthenticatedSettingsExtructRoute
  AuthenticatedSettingsHiristRoute: typeof AuthenticatedSettingsHiristRoute
  AuthenticatedSettingsLinkedinRoute: typeof AuthenticatedSettingsLinkedinRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsExtructRoute: AuthenticatedSettingsExtructRoute,
    AuthenticatedSettingsHiristRoute: AuthenticatedSettingsHiristRoute,
    AuthenticatedSettingsLinkedinRoute: AuthenticatedSettingsLinkedinRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedJobsJobIdRouteRouteChildren {
  AuthenticatedJobsJobIdActivityRoute: typeof AuthenticatedJobsJobIdActivityRoute
  AuthenticatedJobsJobIdCandidatesRoute: typeof AuthenticatedJobsJobIdCandidatesRoute
  AuthenticatedJobsJobIdEditRoute: typeof AuthenticatedJobsJobIdEditRoute
  AuthenticatedJobsJobIdEvaluationsRoute: typeof AuthenticatedJobsJobIdEvaluationsRoute
  AuthenticatedJobsJobIdScoringRoute: typeof AuthenticatedJobsJobIdScoringRoute
  AuthenticatedJobsJobIdIndexRoute: typeof AuthenticatedJobsJobIdIndexRoute
  AuthenticatedJobsJobIdSourcesSourceIdRoute: typeof AuthenticatedJobsJobIdSourcesSourceIdRoute
  AuthenticatedJobsJobIdSourcesIndexRoute: typeof AuthenticatedJobsJobIdSourcesIndexRoute
}

const AuthenticatedJobsJobIdRouteRouteChildren: AuthenticatedJobsJobIdRouteRouteChildren =
  {
    AuthenticatedJobsJobIdActivityRoute: AuthenticatedJobsJobIdActivityRoute,
    AuthenticatedJobsJobIdCandidatesRoute:
      AuthenticatedJobsJobIdCandidatesRoute,
    AuthenticatedJobsJobIdEditRoute: AuthenticatedJobsJobIdEditRoute,
    AuthenticatedJobsJobIdEvaluationsRoute:
      AuthenticatedJobsJobIdEvaluationsRoute,
    AuthenticatedJobsJobIdScoringRoute: AuthenticatedJobsJobIdScoringRoute,
    AuthenticatedJobsJobIdIndexRoute: AuthenticatedJobsJobIdIndexRoute,
    AuthenticatedJobsJobIdSourcesSourceIdRoute:
      AuthenticatedJobsJobIdSourcesSourceIdRoute,
    AuthenticatedJobsJobIdSourcesIndexRoute:
      AuthenticatedJobsJobIdSourcesIndexRoute,
  }

const AuthenticatedJobsJobIdRouteRouteWithChildren =
  AuthenticatedJobsJobIdRouteRoute._addFileChildren(
    AuthenticatedJobsJobIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedJobsJobIdRouteRoute: typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedApolloCompaniesIndexRoute: typeof AuthenticatedApolloCompaniesIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedCandidateChatIndexRoute: typeof AuthenticatedCandidateChatIndexRoute
  AuthenticatedCandidatesIndexRoute: typeof AuthenticatedCandidatesIndexRoute
  AuthenticatedChangelogIndexRoute: typeof AuthenticatedChangelogIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedCompanyChatIndexRoute: typeof AuthenticatedCompanyChatIndexRoute
  AuthenticatedCompanyJobsIndexRoute: typeof AuthenticatedCompanyJobsIndexRoute
  AuthenticatedEvaluationPromptCreationIndexRoute: typeof AuthenticatedEvaluationPromptCreationIndexRoute
  AuthenticatedEvaluationPromptsIndexRoute: typeof AuthenticatedEvaluationPromptsIndexRoute
  AuthenticatedExtructCompaniesIndexRoute: typeof AuthenticatedExtructCompaniesIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedJobCreationIndexRoute: typeof AuthenticatedJobCreationIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedLemlistCandidatesIndexRoute: typeof AuthenticatedLemlistCandidatesIndexRoute
  AuthenticatedLemlistCompaniesIndexRoute: typeof AuthenticatedLemlistCompaniesIndexRoute
  AuthenticatedLinkdapiCandidatesIndexRoute: typeof AuthenticatedLinkdapiCandidatesIndexRoute
  AuthenticatedLinkedinExtCandidatesIndexRoute: typeof AuthenticatedLinkedinExtCandidatesIndexRoute
  AuthenticatedLinkedinJobListIndexRoute: typeof AuthenticatedLinkedinJobListIndexRoute
  AuthenticatedMarkedCandidatesIndexRoute: typeof AuthenticatedMarkedCandidatesIndexRoute
  AuthenticatedNaukriCandidatesIndexRoute: typeof AuthenticatedNaukriCandidatesIndexRoute
  AuthenticatedResumeCandidatesIndexRoute: typeof AuthenticatedResumeCandidatesIndexRoute
  AuthenticatedScoringIndexRoute: typeof AuthenticatedScoringIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTraxcnCompaniesIndexRoute: typeof AuthenticatedTraxcnCompaniesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWeekdayCandidatesIndexRoute: typeof AuthenticatedWeekdayCandidatesIndexRoute
  AuthenticatedEvaluationPromptPromptIdEditRoute: typeof AuthenticatedEvaluationPromptPromptIdEditRoute
  AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute: typeof AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute
  AuthenticatedLinkedinSalesNavigatorBuilderRoute: typeof AuthenticatedLinkedinSalesNavigatorBuilderRoute
  AuthenticatedLinkedinSalesNavigatorNewRoute: typeof AuthenticatedLinkedinSalesNavigatorNewRoute
  AuthenticatedScoringConversationIdDiffRoute: typeof AuthenticatedScoringConversationIdDiffRoute
  AuthenticatedScoringConversationIdEvaluateRoute: typeof AuthenticatedScoringConversationIdEvaluateRoute
  AuthenticatedScoringConversationIdViewRoute: typeof AuthenticatedScoringConversationIdViewRoute
  AuthenticatedCandidateChatConversationIdIndexRoute: typeof AuthenticatedCandidateChatConversationIdIndexRoute
  AuthenticatedCandidatesUidIndexRoute: typeof AuthenticatedCandidatesUidIndexRoute
  AuthenticatedCompaniesUidIndexRoute: typeof AuthenticatedCompaniesUidIndexRoute
  AuthenticatedCompanyChatConversationIdIndexRoute: typeof AuthenticatedCompanyChatConversationIdIndexRoute
  AuthenticatedCompanyJobsJobIdIndexRoute: typeof AuthenticatedCompanyJobsJobIdIndexRoute
  AuthenticatedCompanyJobsMarkedIndexRoute: typeof AuthenticatedCompanyJobsMarkedIndexRoute
  AuthenticatedCompanyJobsTracxnIndexRoute: typeof AuthenticatedCompanyJobsTracxnIndexRoute
  AuthenticatedHiristJobsIndexRoute: typeof AuthenticatedHiristJobsIndexRoute
  AuthenticatedLinkedinCandidatesIndexRoute: typeof AuthenticatedLinkedinCandidatesIndexRoute
  AuthenticatedLinkedinSalesNavigatorIndexRoute: typeof AuthenticatedLinkedinSalesNavigatorIndexRoute
  AuthenticatedNaukriCandidatesIdIndexRoute: typeof AuthenticatedNaukriCandidatesIdIndexRoute
  AuthenticatedScoringConversationIdIndexRoute: typeof AuthenticatedScoringConversationIdIndexRoute
  AuthenticatedTraxcnCompaniesIdIndexRoute: typeof AuthenticatedTraxcnCompaniesIdIndexRoute
  AuthenticatedHiristJobsJobIdIndexRoute: typeof AuthenticatedHiristJobsJobIdIndexRoute
  AuthenticatedLinkedinCandidatesUsernameIndexRoute: typeof AuthenticatedLinkedinCandidatesUsernameIndexRoute
  AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute: typeof AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedJobsJobIdRouteRoute:
    AuthenticatedJobsJobIdRouteRouteWithChildren,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedApolloCompaniesIndexRoute:
    AuthenticatedApolloCompaniesIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedCandidateChatIndexRoute: AuthenticatedCandidateChatIndexRoute,
  AuthenticatedCandidatesIndexRoute: AuthenticatedCandidatesIndexRoute,
  AuthenticatedChangelogIndexRoute: AuthenticatedChangelogIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedCompanyChatIndexRoute: AuthenticatedCompanyChatIndexRoute,
  AuthenticatedCompanyJobsIndexRoute: AuthenticatedCompanyJobsIndexRoute,
  AuthenticatedEvaluationPromptCreationIndexRoute:
    AuthenticatedEvaluationPromptCreationIndexRoute,
  AuthenticatedEvaluationPromptsIndexRoute:
    AuthenticatedEvaluationPromptsIndexRoute,
  AuthenticatedExtructCompaniesIndexRoute:
    AuthenticatedExtructCompaniesIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedJobCreationIndexRoute: AuthenticatedJobCreationIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedLemlistCandidatesIndexRoute:
    AuthenticatedLemlistCandidatesIndexRoute,
  AuthenticatedLemlistCompaniesIndexRoute:
    AuthenticatedLemlistCompaniesIndexRoute,
  AuthenticatedLinkdapiCandidatesIndexRoute:
    AuthenticatedLinkdapiCandidatesIndexRoute,
  AuthenticatedLinkedinExtCandidatesIndexRoute:
    AuthenticatedLinkedinExtCandidatesIndexRoute,
  AuthenticatedLinkedinJobListIndexRoute:
    AuthenticatedLinkedinJobListIndexRoute,
  AuthenticatedMarkedCandidatesIndexRoute:
    AuthenticatedMarkedCandidatesIndexRoute,
  AuthenticatedNaukriCandidatesIndexRoute:
    AuthenticatedNaukriCandidatesIndexRoute,
  AuthenticatedResumeCandidatesIndexRoute:
    AuthenticatedResumeCandidatesIndexRoute,
  AuthenticatedScoringIndexRoute: AuthenticatedScoringIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTraxcnCompaniesIndexRoute:
    AuthenticatedTraxcnCompaniesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWeekdayCandidatesIndexRoute:
    AuthenticatedWeekdayCandidatesIndexRoute,
  AuthenticatedEvaluationPromptPromptIdEditRoute:
    AuthenticatedEvaluationPromptPromptIdEditRoute,
  AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute:
    AuthenticatedLinkedinJobListLinkedinJobIdApplicantsRoute,
  AuthenticatedLinkedinSalesNavigatorBuilderRoute:
    AuthenticatedLinkedinSalesNavigatorBuilderRoute,
  AuthenticatedLinkedinSalesNavigatorNewRoute:
    AuthenticatedLinkedinSalesNavigatorNewRoute,
  AuthenticatedScoringConversationIdDiffRoute:
    AuthenticatedScoringConversationIdDiffRoute,
  AuthenticatedScoringConversationIdEvaluateRoute:
    AuthenticatedScoringConversationIdEvaluateRoute,
  AuthenticatedScoringConversationIdViewRoute:
    AuthenticatedScoringConversationIdViewRoute,
  AuthenticatedCandidateChatConversationIdIndexRoute:
    AuthenticatedCandidateChatConversationIdIndexRoute,
  AuthenticatedCandidatesUidIndexRoute: AuthenticatedCandidatesUidIndexRoute,
  AuthenticatedCompaniesUidIndexRoute: AuthenticatedCompaniesUidIndexRoute,
  AuthenticatedCompanyChatConversationIdIndexRoute:
    AuthenticatedCompanyChatConversationIdIndexRoute,
  AuthenticatedCompanyJobsJobIdIndexRoute:
    AuthenticatedCompanyJobsJobIdIndexRoute,
  AuthenticatedCompanyJobsMarkedIndexRoute:
    AuthenticatedCompanyJobsMarkedIndexRoute,
  AuthenticatedCompanyJobsTracxnIndexRoute:
    AuthenticatedCompanyJobsTracxnIndexRoute,
  AuthenticatedHiristJobsIndexRoute: AuthenticatedHiristJobsIndexRoute,
  AuthenticatedLinkedinCandidatesIndexRoute:
    AuthenticatedLinkedinCandidatesIndexRoute,
  AuthenticatedLinkedinSalesNavigatorIndexRoute:
    AuthenticatedLinkedinSalesNavigatorIndexRoute,
  AuthenticatedNaukriCandidatesIdIndexRoute:
    AuthenticatedNaukriCandidatesIdIndexRoute,
  AuthenticatedScoringConversationIdIndexRoute:
    AuthenticatedScoringConversationIdIndexRoute,
  AuthenticatedTraxcnCompaniesIdIndexRoute:
    AuthenticatedTraxcnCompaniesIdIndexRoute,
  AuthenticatedHiristJobsJobIdIndexRoute:
    AuthenticatedHiristJobsJobIdIndexRoute,
  AuthenticatedLinkedinCandidatesUsernameIndexRoute:
    AuthenticatedLinkedinCandidatesUsernameIndexRoute,
  AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute:
    AuthenticatedLinkedinSalesNavigatorJobIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
